import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Form,
  Tab,
  Nav,
  Button,
  Dropdown,
  Row,
  Col,
  ListGroup,
  Modal,
  Card,
} from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import ReactFsLightbox from "fslightbox-react";
import { TbFileUpload, TbPhoneCall } from "react-icons/tb";
import { toast } from 'react-toastify';
import { FaFacebook, FaFile, FaInstagram, FaVideo, FaWhatsapp } from "react-icons/fa";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
//img

import user1 from "../../../assets/images/user/users.png";
//scrollbar
import { useDispatch, useSelector } from "react-redux";
import {
  instagramsendmessage,
} from "../../../store/instagram/instagramThunk";
import { uploadFileToCloudinary } from "../../../store/Cloudinary/CloudinaryThunk";
import {
  facebooksendmessage,
  FBautochat,
  fetchFBConversations,
  getFBConversationByUser,
  resetUnreadCount,
} from "../../../store/facebook/facebookThunk";
import EmojiPicker from "emoji-picker-react";
import { getQuickreplyAllData } from "../../../store/Quickreply/QuickreplyThunk";
import MeetModel from "./meetModel";
import { Audio, Circles, Hourglass, ThreeDots } from 'react-loader-spinner'
import { generateMeeting } from "../../../store/google/googleThunk";
import { userProfile } from "../../../store/user/userThunk";
import ScheduleMessageModal from "../../../components/ScheduleMessageModal";
import { getTemplatesById, sendWpMessage } from "../../../store/whatsApp/wpThunks";
import ChatInput from "../../../components/chatInput";

const AllChat = () => {
  // ========== State Management ==========
  // Core state
  const [chats, setChats] = useState(null);
  const [currentChatId, setCurrentChatId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [chatLoader, setChatLoader] = useState(false);
  const [loadingInitialData, setLoadingInitialData] = useState(true);
  const [Loader, setLoader] = useState(false)
  const [scrollchat, setscrollchat] = useState(false);



  // Chat metadata
  const [senderId, setSenderId] = useState(null);
  const [receiverId, setReceiverId] = useState(null);
  const [platform, setPlatform] = useState(null);
  const [messageNavbar, setMessageNavbar] = useState(null);
  const [userName, setUserName] = useState(false);
  const [ChatUserId, setChatUserId] = useState(false);
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [instagramAccountId, setInstagramAccountId] = useState(null);
  const [payloadValues, setPayloadValues] = useState([]);
  const [show4, setShow4] = useState(false);
  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true);
  // User message tracking
  const [hasUserMessages, setHasUserMessages] = useState(null);
  const [lastUserMessageDate, setLastUserMessageDate] = useState(null);
  const [humanagent, setHumanagent] = useState(null);
  const [canSendTemplate, setCanSendTemplate] = useState();
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  console.log(canSendTemplate, "canSendTemplatecanSendTemplatecanSendTemplatecanSendTemplate")
  // UI state
  const [searchTerm, setSearchTerm] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [Showimg, setShowimg] = useState(null);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [showquickreply, setShowQuickReply] = useState(false);
  console.log(showquickreply, "?showquickreplyshowquickreplyshowquickreply")
  const [filteredQuickReplies, setFilteredQuickReplies] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [generatedLink, setGeneratedLink] = useState(null);
  const [templates, setTemplates] = useState(null);
  const [show6, setShow6] = useState(false);
  const [faqs, setFaqs] = useState(null);
  const [imageController, setImageController] = useState({
    toggler: false,
    slide: 1,
  });
  const [image, setImage] = useState("");

  // Refs
  const inputFile = useRef(null);
  const emojiPickerRef = useRef(null);
  const sectionRef = useRef(null);
  const inputRef = useRef(null);

  // Constants
  const limit = 20;

  // Redux state
  const dispatch = useDispatch();
  const {
    conversations,
    loading,
    conversationDetails,
    fbSendMessageloading,
    convLoading,
    error,
    message,
    getFBConversationByUserloading
  } = useSelector((state) => state.facebook);
  const {
    usergetTemplatesFullfill,
    getTemplatesError,
    getTemplatesByIdFullfill,
    getTemplatesByIdError,
  } = useSelector((state) => state.whatsapp);
  const { generateMeetingFullfill } = useSelector((state) => state.google);
  const { uploadStatus, uploadedFile, uploadError } = useSelector(
    (state) => state.cloudinary
  );
  const { profile } = useSelector((state) => state.userservice);
  const { igSendMessageloading } = useSelector((state) => state.instagram);
  const { getQuickreplyLoding, getQuickreplyerrer, getQuickreplySuccess } =
    useSelector((state) => state.Quickreply);

  // FSLightbox component
  const FsLightbox = ReactFsLightbox.default
    ? ReactFsLightbox.default
    : ReactFsLightbox;

  // ========== Helper Functions ==========
  const handleOpenScheduleModal = () => setShowScheduleModal(true);
  const handleCloseScheduleModal = () => setShowScheduleModal(false);
  const handleClose6 = () => setShow6(false);

  const scrollToBottom = async () => {
    if (sectionRef.current) {
      await sectionRef.current.scrollTo(0, sectionRef.current.scrollHeight);
      setscrollchat(false)
    }
  };

  const handleCopy = (message) => {
    navigator.clipboard.writeText(message);
  };

  const minisidebar = () => {
    const sidebar = document.getElementById("chatsidebar");
    if (sidebar) {
      sidebar.classList.toggle("sidebar-mini2");
    } else {
      console.error("Element with id 'sidebar' not found");
    }
  };

  // ========== WebSocket Connection ==========
  const navigate = useNavigate()
  useEffect(() => {
    // if (profile === null)
    dispatch(userProfile()).then((resp) => {
      const profile = resp.payload
      const isLoggedIn = profile && (profile.iglogin || profile.Fblogin || profile.wpLogin);
      if (!isLoggedIn) {
        navigate('/settings');
      }
      console.log(resp.payload, "respresprespresp")
    }).catch((error) => {
      console.log(error)
    })
  }, [dispatch])

  const getUpdatedText = () => {
    if (!selectedTemplate) return 'No Message Type Selected';

    const template = templates.find((t) => t._id === selectedTemplate?._id);
    if (!template?.components) return 'No Message Type Selected';

    const updatedComponents = template.components.map((component, compIndex) => {
      const textSegments = component.text?.split(/({{\d+}})/g) || [];
      return textSegments.map((segment, index) => {
        const match = segment.match(/{{(\d+)}}/);
        if (match) {
          const key = parseInt(match[1], 10);
          const value = key === 1 ? payloadValues[key] || 'test' : payloadValues[key] || '';
          return <strong key={`${compIndex}-${index}`}>{value}</strong>;
        }
        return segment;
      });
    });

    return updatedComponents.flat();
  };


  useEffect(() => {
    const ws = new WebSocket("wss://socialv.settingsinfotech.com:2000");

    ws.onmessage = async (event) => {
      try {
        const message = JSON.parse(event.data);
        console.log(message, "vvvmessagemessagemessagemessage")
        if (message.type === "read_receipt") {
          const { sender, watermark, recipient } = message;
          setMessages((prevMessages) =>
            prevMessages.map((msg) =>
              msg.from.id === recipient && new Date(msg.created_time)
                ? { ...msg, read: true }
                : msg
            )
          );
        }
        else if (message?.type === "message") {
          const {
            sender,
            recipient,
            thread_Id,
            text,
            timestamp,
            platform,
            participants,
            userName,
            // attachments,
            shares,
            mid,
            imageUrl,
            documentUrl,
            documentName,
            attachmentTitle,
            audioUrl,
            videoUrl,
            unreadCount
          } = message;
          console.log(message, "messagemessagemessage--------------")
          // Update messages list
          console.log(sender, 'sender sender sender ')
          console.log(recipient, "recipientrecipientrecipient")
          console.log(senderId, "senderIdsenderIdsenderIdsenderId")
          console.log(sender === senderId, "sender === senderIdsender === senderIdsender === senderId")
          console.log(recipient === senderId, "recipient === senderIdrecipient === senderIdrecipient === senderId")
          console.log(documentUrl, "documentUrldocumentUrldocumentUrldocumentUrl")
          console.log(documentName, "documentNamedocumentNamedocumentNamedocumentName")
          console.log(audioUrl, "audioUrlaudioUrlaudioUrlaudioUrlaudioUrl")
          if (sender === senderId || recipient === senderId) {
            setscrollchat(true)
            setHasUserMessages(true)
            setLastUserMessageDate(timestamp)
            setCanSendTemplate(false)
            setMessages((prevMessages) => [
              ...prevMessages,
              {
                id: mid,
                message: text,
                created_time: timestamp,
                from: { id: sender },
                platform,
                read: false,
                // attachments: {
                //   data: [{ image_data: { url: attachments?.image_data?.url } }],
                // },
                attachments: {
                  data: [
                    ...(imageUrl ? [{ image_data: { url: imageUrl } }] : []),
                    ...(videoUrl ? [{ video_data: { url: videoUrl } }] : []),
                    ...(documentUrl
                      ? [{ name: documentName, file_url: documentUrl }]
                      : []),
                    ...(audioUrl // Check if audioUrl exists
                      ? [
                        {
                          audio_data: {
                            url: audioUrl, // You might need to change this based on your data structure
                          },
                          file_url: audioUrl, // URL to the audio file
                        },
                      ]
                      : []),
                  ],
                },
                shares: {
                  data: [
                    ...(shares?.link && shares?.type
                      ? [
                        {
                          link: shares.link,
                          type: shares.type,
                        },
                      ]
                      : []),
                  ],
                },

              },
            ]);
          }
          // Update chat preview
          setChats((prevChats) => {
            const updatedChats = [...prevChats];
            const chatIndex = updatedChats.findIndex((chat) => {
              const participantId = chat.originalData?.participants?.data?.[0]?.id;
              console.log(participantId, "participantIdparticipantId")
              console.log(sender, "sendersendersender")
              console.log(recipient, "recipientrecipientrecipient")
              console.log(participantId === sender, "participantId === recipientparticipantId === recipientparticipantId === recipient")
              console.log(participantId === recipient, "participantId === senderparticipantId === senderparticipantId === sender")

              return participantId === sender || participantId === recipient;
            });
            console.log(thread_Id, "thread_Idthread_Idthread_Idthread_Id")
            console.log(currentChatId, "currentChatIdcurrentChatIdcurrentChatIdcurrentChatId")

            if (chatIndex !== -1) {
              const existingChat = updatedChats[chatIndex];
              const isActiveChat = existingChat.originalData.id === currentChatId;
              const updatedChat = {
                ...existingChat,
                originalData: {
                  ...existingChat.originalData,
                  LastMessage: text,
                  LastMessageTime: timestamp,
                  unreadCount: isActiveChat ? 0 : unreadCount
                },
              };

              updatedChats.splice(chatIndex, 1);
              console.log(updatedChats, "updatedChatsupdatedChatsupdatedChats")

              if (isActiveChat) {
                dispatch(resetUnreadCount({ senderId: senderId, platform }));
              }
              return [updatedChat, ...updatedChats];
            }

            // Create new conversation if not found
            let finalUserName = userName;
            console.log(finalUserName, "finalUserNamefinalUserName")
            console.log(participants, "participantsparticipantsparticipantsparticipants")
            console.log(participants?.data, "participants?.dataparticipants?.dataparticipants?.dataparticipants?.data")
            if (!finalUserName && participants?.data?.length > 0) {
              const matched = participants.data.find((p) => p.id !== senderId);
              if (matched?.name) finalUserName = matched.name;
            }

            const newChat = {
              platform,
              originalData: {
                LastMessageTime: Date.now(),
                id: thread_Id,
                LastMessage: text,
                participants: {
                  data: [{ name: finalUserName, id: sender }],
                },
                unreadCount: unreadCount
              },
            };

            return [newChat, ...updatedChats];
          });

          // if (thread_Id === currentChatId ) {
          //   dispatch(resetUnreadCount({ senderId: senderId, platform }));
          // }
          setNewMessage("");
        }

        else if (message?.type === "conversations") {
          const {
            sender,
            recipient,
            text,
            timestamp,
            platform,
            participants,
          } = message;

          setChats((prevChats) => {
            const updatedChats = [...prevChats];

            // Find existing chat
            const existingIndex = updatedChats.findIndex(
              (chat) =>
                chat.originalData?.participants?.data?.[0]?.id === sender
            );

            if (existingIndex !== -1) {
              // Update & move to top
              const existingChat = updatedChats[existingIndex];
              const updatedChat = {
                ...existingChat,
                originalData: {
                  LastMessageTime: timestamp,
                  ...existingChat.originalData,
                  LastMessage: text,
                },
              };

              updatedChats.splice(existingIndex, 1); // remove old one
              return [updatedChat, ...updatedChats];
            }

            // If not found, create new chat
            let userName = "Unknown User";
            const matched = participants?.data?.find((p) => p.id !== senderId);
            if (matched?.name) userName = matched.name;

            const newChat = {
              platform: platform, // fallback if platform missing
              originalData: {
                id: sender,
                LastMessage: text,
                LastMessageTime: timestamp,
                participants: {
                  data: [{ name: userName, id: sender }],
                },
              },
            };

            return [newChat, ...updatedChats];
          });
        } else if (message.type === "delete_message") {
          setMessages((prevMessages) => {
            const updatedMessages = prevMessages.filter((msg) => msg?.id && msg.id !== message.messageId);
            return [...updatedMessages];
          });
          sectionRef.current?.scrollTo(0, sectionRef.current.scrollHeight);
        }

        else if (message.type === "postback") {
          const { sender, recipient, payload, title } = message;
          if (sender === senderId || recipient === senderId) {
            setMessages((prevMessages) => [
              ...prevMessages,
              {
                message: title,
                from: { id: sender },
                read: false,
              },
            ]);
          }
          setNewMessage("");
        }


      } catch (error) {
        console.error("❌ Error parsing WebSocket message:", error);
      }
    };

    return () => {
      ws.close();
    };
  }, [senderId]);

  // ========== Data Loading Functions ==========
  const loadInitialData = () => {
    setLoadingInitialData(true);
    if (!profile) {
      dispatch(userProfile());
    }
    setChatLoader(true);
    dispatch(getQuickreplyAllData());
    dispatch(fetchFBConversations())
      .then((response) => {
        const conversationsList = response.payload;
        if (conversationsList && conversationsList.length > 0) {
          // First set chats list
          setChats(conversationsList);
          // Select first conversation
          const firstChat = conversationsList[0];
          const chatId = firstChat?.originalData?.id;
          const chatPlatform = firstChat?.platform;

          // Set metadata first to avoid UI flickering
          setCurrentChatId(chatId);
          setPlatform(chatPlatform);
          setSenderId(firstChat?.originalData?.participants?.data[0]?.id);
          setReceiverId(firstChat?.originalData?.participants?.data[1]?.id);
          setMessageNavbar(firstChat?.originalData);
          setIsSwitchOn(firstChat?.autochat);

          // Then load messages for first conversation
          return loadMessages(chatId, chatPlatform, 1);
        }

        return null;
      })
      .finally(() => {
        setLoadingInitialData(false);
        setChatLoader(false);

      });

    // ...rest of function
  };
  const getFileExtension = (filename) => {
    return filename.split('.').pop().toLowerCase();
  };
  const getFileIcon = (filename) => {
    const extension = getFileExtension(filename);
    const iconMap = {
      pdf: '📄',
      doc: '📝', docx: '📝',
      xls: '📊', xlsx: '📊',
      ppt: '📊', pptx: '📊',
      txt: '📄',
      zip: '🗂️', rar: '🗂️',
      mp3: '🎵', wav: '🎵',
      mp4: '🎬', avi: '🎬',
      jpg: '🖼️', jpeg: '🖼️', png: '🖼️', gif: '🖼️',
    };
    return iconMap[extension] || '📄';
  };

  useEffect(() => {
    Fancybox.bind("[data-fancybox]", {
      Toolbar: {
        display: {
          left: ["infobar"],
          middle: [
            "zoomIn",
            "zoomOut",
            "toggle1to1",
            "rotateCCW",
            "rotateCW",
            "flipX",
            "flipY",
          ],
          right: ["slideshow", "thumbs", "close"],
        },
      },
      Thumbs: {
        autoStart: false,
      },
      // Add download button
      Toolbar: {
        display: {
          left: ["infobar"],
          middle: [
            "zoomIn",
            "zoomOut",
            "toggle1to1",
            "rotateCCW",
            "rotateCW",
            "flipX",
            "flipY",
          ],
          right: [
            {
              tpl: '<button class="f-button" title="Download"><svg><use xlink:href="#icon-download"></use></svg></button>',
              click: function (instance) {
                const currentSlide = instance.getSlide();
                const link = document.createElement('a');
                link.href = currentSlide.src;
                link.download = 'image';
                link.click();
              }
            },
            "slideshow",
            "thumbs",
            "close"
          ],
        },
      },
    });

    return () => {
      Fancybox.destroy();
    };
  }, []);


  useEffect(() => {
    setFaqs(getQuickreplySuccess?.data);
  }, [getQuickreplySuccess]);

  const loadMessages = (chatId, chatPlatform, pageNum) => {
    if (!chatId) return Promise.reject("No chat ID provided");

    return dispatch(getFBConversationByUser({
      currentChatId: chatId,
      page: pageNum,
      limit,
      platform: chatPlatform
    }))
      .then((response) => {
        const data = response.payload;

        // Process conversation details
        if (pageNum === 1) {
          setscrollchat(true)
        }

        console.log(data?.hasLastUserMessageTime, 'data?.hasLastUserMessageTimedata?.hasLastUserMessageTimedata?.hasLastUserMessageTime')
        setChatUserId(data?.me);
        setHasUserMessages(data?.hasUserMessages);
        setInstagramAccountId(data?.recipient);
        setLastUserMessageDate(data?.hasLastUserMessageTime);
        setIsSwitchOn(data?.autochat);
        if (chatPlatform === "instagram" || chatPlatform === "whatsapp") {
          checkMessageTimeout();
        }

        // Update messages
        if (data?.data) {
          if (pageNum === 1) {
            // First page, replace messages
            const reversedData = [...data.data].reverse();
            setMessages(reversedData);
          } else {
            // Additional pages, prepend to existing messages
            const reversedData = [...data.data].reverse();
            setMessages((prevMessages) => [...reversedData, ...prevMessages]);
          }
        }

        // Update pagination state
        if (data?.data?.length < limit) {
          setHasMore(false);
        }

        return data;
      })
      .catch((error) => {
        console.error("Error loading messages:", error);
      })
      .finally(() => {
      });
  };

  // ========== User Interaction Handlers ==========
  const location = useLocation();

  const handleChatSelect = async (item) => {
    const senderId = item?.originalData?.participants?.data[0]?.id;
    const receiverId = item?.originalData?.participants?.data[1]?.id;
    const conversationId = item?.originalData?.id;
    setChatLoader(true);

    setscrollchat(true)
    // Reset unread count with all necessary identification data
    dispatch(resetUnreadCount({
      senderId,
      platform: item?.platform,
    })).unwrap()

    // Also update the local state immediately for chats
    // if (chats) {
    //   const updatedChats = chats.map(chat => {
    //     if (chat?.originalData?.id === conversationId) {
    //       return {
    //         ...chat,
    //         originalData: {
    //           ...chat.originalData,
    //           unreadCount: 0
    //         }
    //       };
    //     }
    //     return chat;
    //   });

    //   // Update local state
    //   setChats(updatedChats);
    // }

    setChats((prevChats) =>
      prevChats.map((chat) =>
        chat.originalData.id === conversationId
          ? {
            ...chat,
            originalData: { ...chat.originalData, unreadCount: 0 },
          }
          : chat
      )
    );
    setCurrentChatId(conversationId);
    setUserName(item?.originalData?.participants?.data[0]?.name);
    setPlatform(item?.platform);
    setMessageNavbar(item?.originalData);
    // setIsSwitchOn(item?.originalData?.autochat);
    setShowQuickReply(false);
    setSenderId(senderId);
    setReceiverId(receiverId);
    setNewMessage("");
    setGeneratedLink("");
    setMessages([]);
    setPage(1);
    setHasMore(true);

    // Load messages for the selected chat
    await loadMessages(conversationId, item?.platform, 1)
    setChatLoader(false);

  };



  const handleScroll = () => {
    const container = sectionRef.current;
    if (!container || isLoading) return;

    // Only trigger pagination when we're at the top of the container
    if (container.scrollTop <= 5) {
      if (!hasMore) {
        return;
      }

      // Measure current position before loading new messages
      const currentScrollHeight = container.scrollHeight;
      const nextPage = page + 1;

      setIsLoading(true);
      setPage(nextPage);

      // Use isPagination flag to prevent loader and blinking
      loadMessages(currentChatId, platform, nextPage, true)
        .then(() => {
          // After new messages are loaded and rendered, restore scroll position
          setTimeout(() => {
            if (container) {
              const newScrollHeight = container.scrollHeight;
              const scrollDifference = newScrollHeight - currentScrollHeight;
              container.scrollTop = scrollDifference > 0 ? scrollDifference : 0;
            }
            setIsLoading(false);
          }, 50); // Small delay to ensure DOM has updated
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const loginStatus = urlParams.get('login');
    const provider = urlParams.get('provider');

    if (loginStatus === 'success' && provider) {
      toast.success(`${provider.charAt(0).toUpperCase() + provider.slice(1)} account connected successfully!`);

      // Clean up URL
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);

  const handleSendMessage = async (messagePlatform) => {
    console.log("Message Platform:", messagePlatform);
    console.log("Can Send Template:", canSendTemplate);
    console.log("Selected Template:", selectedTemplate);
    console.log(senderId, "senderIdsenderIdsenderId")
    if (!senderId) {
      console.warn("Message or senderId is missing");
      return;
    }

    const tempId = `temp-${Date.now()}`;
    const timestamp = new Date().toISOString();

    // Add optimistic message
    const optimisticMessage = {
      id: tempId,
      message: newMessage,
      created_time: timestamp,
      from: { id: instagramAccountId }, // Adjust if needed for WhatsApp
      platform: messagePlatform,
      read: false,
    };

    setMessages((prevMessages) => [...prevMessages, optimisticMessage]);

    setChats((prevChats) => {
      const updatedChats = [...prevChats];
      const chatIndex = updatedChats.findIndex((chat) => {
        const participantId = chat.originalData?.participants?.data?.[0]?.id;
        return participantId === senderId;
      });

      if (chatIndex !== -1) {
        const existingChat = updatedChats[chatIndex];
        const updatedChat = {
          ...existingChat,
          originalData: {
            ...existingChat.originalData,
            LastMessage: newMessage,
            LastMessageTime: timestamp,
          },
        };
        updatedChats.splice(chatIndex, 1);
        return [updatedChat, ...updatedChats];
      }
      return updatedChats; // Return unchanged if no chat found
    });

    try {
      let messageData = null;

      if (messagePlatform === "facebook") {
        messageData = {
          messaging_type: "MESSAGE_TAG",
          recipient: { id: senderId },
          message: { text: newMessage },
          tag: "POST_PURCHASE_UPDATE",
        };

        await dispatch(facebooksendmessage(messageData));
        setNewMessage("");
        scrollToBottom();
      } else if (messagePlatform === "instagram") {
        messageData = {
          recipient: { id: senderId },
          message: { text: newMessage },
        };

        if (humanagent) {
          messageData.tag = "HUMAN_AGENT";
        }

        await dispatch(instagramsendmessage(messageData));
        setNewMessage("");
        scrollToBottom();
      } else if (messagePlatform === "whatsapp") {
  // WhatsApp message handling
  if (canSendTemplate && selectedTemplate && templates?.length > 0) {
    console.log("Attempting to send WhatsApp template message");
    console.log("Selected Template ID:", selectedTemplate._id);
    console.log("Available Templates:", templates);

    // Find the template
    const template = templates.find((t) => t._id === selectedTemplate._id);
    if (!template) {
      console.error("Selected template not found in templates list");
      throw new Error("Template not found");
    }

    // Map components for the template
    const components = template.components
      .map((component) => {
        if (!component.text) {
          return {
            type: component.type.toLowerCase(),
          };
        }

        const placeholders = component.text.match(/{{\d+}}/g) || [];
        if (placeholders.length === 0) {
          return {
            type: component.type.toLowerCase(),
            text: component.text,
          };
        }

        const parameters = placeholders.map((placeholder) => {
          const key = parseInt(placeholder.match(/{{(\d+)}}/)[1], 10);
          const value = payloadValues[key];
          if (!value) {
            console.warn(`Missing payload value for placeholder {{${key}}}`);
            throw new Error(`Missing value for placeholder {{${key}}}`);
          }
          return {
            type: "text",
            text: value,
          };
        });

        return {
          type: component.type.toLowerCase(),
          parameters,
        };
      })
      .filter(Boolean);

    messageData = {
      messaging_product: "whatsapp",
      to: senderId,
      type: "template",
      template: {
        name: template.templateName,
        language: {
          code: template.languageCode,
        },
        components,
      },
    };

    console.log("Template Message Data:", messageData);
    await dispatch(sendWpMessage(messageData));
    setPayloadValues({}); // Clear payload values after sending template
  } else {
    console.log("Sending plain text WhatsApp message");
    // Send plain text message
    messageData = {
      messaging_product: "whatsapp",
      to: senderId,
      type: "text",
      text: {
        body: newMessage,
      },
    };

    console.log("Plain Text Message Data:", messageData);
    await dispatch(sendWpMessage(messageData));
  }

  setNewMessage("");
  scrollToBottom();
}else {
        console.error("Unsupported message platform:", messagePlatform);
        throw new Error("Unsupported message platform");
      }
    } catch (error) {
      console.error(`Error sending ${messagePlatform} message:`, error);
      // Remove optimistic message on failure
      setMessages((prevMessages) =>
        prevMessages.filter((msg) => msg.id !== tempId)
      );
      // Optionally, show user feedback (e.g., toast notification)
      alert(`Failed to send message: ${error.message}`);
    }
  };

  // ========== File Upload Handlers ==========
  const handleFileUpload = (e) => {
    const { files } = e.target;

    console.log(files, "filesfilesfilesfilesfilesfilesfiles")

    if (files.length === 0 || !senderId) return;

    const file = files[0];

    dispatch(uploadFileToCloudinary(file))
      .then((response) => {
        const fileUrl = response.payload?.url;
        if (fileUrl) {
          handleSendFileMessage(fileUrl);
        }
      })
      .catch((error) => {
        console.error("File upload error:", error);
      });
  };

  const handleSendFileMessage = (fileUrl) => {
    if (!senderId || !fileUrl) return;

    console.log(fileUrl, "fileUrlfileUrlfileUrlfileUrl")
    const fileType = inputFile.current?.files[0]?.type || '';
    console.log(fileType, "fileTypefileTypefileTypefileType")
    let attachmentType = 'file';

    if (fileType.startsWith("image/")) attachmentType = "image";
    else if (fileType.startsWith("video/")) attachmentType = "video";

    let messageData = null;

    if (platform === "facebook") {
      messageData = {
        recipient: { id: senderId },
        message: {
          attachment: {
            type: attachmentType === "file" ? "file" : attachmentType,
            payload: {
              url: fileUrl,
              is_reusable: true,
            },
          },
        },
        tag: "POST_PURCHASE_UPDATE"
      };

      dispatch(facebooksendmessage(messageData))
        .then(() => scrollToBottom())
        .catch((error) => {
          console.error("Error sending Facebook file message:", error);
        });

    } else if (platform === "instagram") {
      if (attachmentType === "image" || attachmentType === "video") {
        messageData = {
          recipient: { id: senderId },
          message: {
            attachment: {
              type: attachmentType,
              payload: {
                url: fileUrl,
                is_reusable: true,
              },
            },
          },
        };

        if (humanagent) {
          messageData.tag = "HUMAN_AGENT";
        }

        dispatch(instagramsendmessage(messageData))
          .then(() => scrollToBottom())
          .catch((error) => {
            console.error("Error sending Instagram file message:", error);
          });

      } else {
        alert("Instagram only supports image/video uploads.");
      }

    } else if (platform === "whatsapp") {
      messageData = {
        messaging_product: "whatsapp",
        to: senderId,
        type: attachmentType,
        [attachmentType]: {
          link: fileUrl,
        },
      };

      dispatch(sendWpMessage(messageData))
        .then(() => scrollToBottom())
        .catch((error) => {
          console.error("Error sending WhatsApp file message:", error);
        });
    }
  };

  // ========== Client Side Effects ==========
  // Check for user message timeout (24h rule)
  // const checkMessageTimeout = (timestamp = null) => {
  //   // Use provided timestamp or fall back to state
  //   const dateToCheck = timestamp || lastUserMessageDate;

  //   if (dateToCheck) {
  //     const messageDate = new Date(dateToCheck);
  //     const now = new Date();

  //     // For 24-hour check
  //     const after24Hours = new Date(messageDate);
  //     after24Hours.setHours(after24Hours.getHours() + 24);

  //     // For 7-day check
  //     const after7Days = new Date(messageDate);
  //     after7Days.setDate(after7Days.getDate() + 7);

  //     // Set humanAgent if 24 hours passed
  //     setHumanagent(now > after24Hours);

  //     // Reset hasUserMessages flag if 7 days passed
  //     if (now > after7Days) {
  //       setHasUserMessages(false);
  //     } else {
  //       // Ensure we set this to true if we have messages less than 7 days old
  //       setHasUserMessages(true);
  //     }
  //   } else {
  //     // No message date means no user messages
  //     setHasUserMessages(false);
  //     setHumanagent(false);
  //   }
  // };

  const checkMessageTimeout = (timestamp = null, platformOverride = null) => {
    const currentPlatform = platformOverride || platform; // Use override if providedGenerated Meeting LinkGenerated Meeting Link
    console.log(currentPlatform, "currentPlatformcurrentPlatformcurrentPlatform")
    console.log(lastUserMessageDate, "lastUserMessageDate")
    const dateToCheck = timestamp || lastUserMessageDate;

    console.log(dateToCheck, "dateToCheck")
    if (!dateToCheck) {
      setHasUserMessages(false);

      if (currentPlatform === "whatsapp") {
        setCanSendTemplate(false);
      } else if (currentPlatform !== "facebook") {
        setHumanagent(false);
      }
      return;
    }

    const messageDate = new Date(dateToCheck);
    const now = new Date();

    if (currentPlatform === "whatsapp") {
      const after24Hours = new Date(messageDate);
      after24Hours.setHours(after24Hours.getHours() + 24);

      const is24HoursPassed = now > after24Hours;
      console.log(is24HoursPassed, "is24HoursPassedis24HoursPassedis24HoursPassed")
      setCanSendTemplate(is24HoursPassed);
      // setCanSendTemplate(is24HoursPassed);
    } else if (currentPlatform === "instagram") {
      const after24Hours = new Date(messageDate);
      after24Hours.setHours(after24Hours.getHours() + 24);

      const after7Days = new Date(messageDate);
      after7Days.setDate(after7Days.getDate() + 7);

      setHumanagent(now > after24Hours);
      setHasUserMessages(now <= after7Days);
    } else {
      setHasUserMessages(true);
    }
  };


  // Handle meeting link generation
  const handleMeetingLinkGeneration = () => {
    if (generateMeetingFullfill?.status === 200) {
      setGeneratedLink(generateMeetingFullfill?.meetLink);
    }
  };

  // ========== Component Lifecycle Management ==========
  // Initialize component
  useEffect(() => {
    // This is our main initialization function
    const cleanup = loadInitialData();
    return cleanup;
  }, []);

  // Scroll to bottom when messages change
  useEffect(() => {
    if (scrollchat == true) {
      scrollToBottom()
    }
  }, [handleChatSelect]);

  // Check message timeout when lastUserMessageDate changes
  useEffect(() => {
    console.log(lastUserMessageDate, platform, "lastUserMessageDate, platform")
    if (platform === "instagram") {
      checkMessageTimeout();
    } else if (platform === "whatsapp") {
      checkMessageTimeout();
      // setHasUserMessages(true);
    } else {
      return
    }
  }, [lastUserMessageDate, platform]);

  // Handle meeting link generation
  useEffect(() => {
    handleMeetingLinkGeneration();
  }, [generateMeetingFullfill]);
  // const handleSendMessage = async (platform) => {
  //   if (newMessage.trim() === "" || !senderId) return;
  //   const tempId = `temp-${Date.now()}`;
  //   const timestamp = new Date().toISOString();

  //   console.log(senderId ,"senderIdsenderIdsenderIdsenderId")
  //   // let actualSenderId = instagramAccountId;
  //   let actualReceiverId = senderId;

  //   // if (profile?.igUserId === ChatUserId || profile?.fbUserId === ChatUserId) {
  //   //   // If both are platform users, swap
  //   //   // actualSenderId = senderId;
  //   //   actualReceiverId = senderId;
  //   // }

  //   // ✅ For UI: Optimistically show message
  //   const optimisticMessage = {
  //     id: tempId,
  //     message: newMessage,
  //     created_time: timestamp,
  //     to: { id: actualReceiverId },
  //     platform,
  //     read: false,
  //   };
  //   setMessages((prevMessages) => [...prevMessages, optimisticMessage]);
  //   // ✅ Update chat preview
  //   setChats((prevChats) => {
  //     const updatedChats = [...prevChats];
  //     const chatIndex = updatedChats.findIndex((chat) => {
  //       const participantId = chat.originalData?.participants?.data?.[0]?.id;
  //       return participantId === senderId;
  //     });

  //     if (chatIndex !== -1) {
  //       const existingChat = updatedChats[chatIndex];
  //       const updatedChat = {
  //         ...existingChat,
  //         originalData: {
  //           ...existingChat.originalData,
  //           LastMessage: newMessage,
  //           LastMessageTime: timestamp,
  //         },
  //       };
  //       updatedChats.splice(chatIndex, 1);
  //       return [updatedChat, ...updatedChats];
  //     }
  //     return updatedChats;
  //   });

  //   try {
  //     let messageData = null;

  //     // ✅ API payload construction with swapped IDs
  //     if (platform === "facebook") {
  //       messageData = {
  //         messaging_type: "MESSAGE_TAG",
  //         recipient: { id: actualReceiverId },  // ✅ Receiver in payload
  //         message: { text: newMessage },
  //         tag: "POST_PURCHASE_UPDATE",
  //       };
  //       await dispatch(facebooksendmessage(messageData));
  //     } else if (platform === "instagram") {
  //       messageData = {
  //         recipient: { id: actualReceiverId },  // ✅ Receiver in payload
  //         message: { text: newMessage },
  //       };
  //       if (humanagent) {
  //         messageData.tag = "HUMAN_AGENT";
  //       }
  //       await dispatch(instagramsendmessage(messageData));
  //     } else if (platform === "whatsapp") {
  //       alert("WhatsApp send message functionality is not implemented yet.");
  //     }
  //   } catch (error) {
  //     console.error("Error sending message:", error);
  //   }
  // };

  const handleDownload = async (url, filename) => {
    try {
      const response = await fetch(url, {
        mode: 'cors', // Use 'cors' if server allows it; otherwise 'no-cors' results in opaque blob
      });

      if (!response.ok) throw new Error('Network response was not ok');

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();

      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      if (url) {
        window.open(url, '_blank');
      } else {
        alert('Download failed. File may be protected or unavailable.');
      }
    }
  };

  const onButtonClick = () => {
    inputFile.current.click();
  };

  const onPhoneCall = async () => {
    setGeneratedLink("")
    setShow6(true)
    await dispatch(generateMeeting())
  }

  let handleQuickReplies = (payload) => {
    if (payload) {
      setNewMessage(payload);
      setShowQuickReply(false);
    }
  };
  const handleSwitchChange = async () => {
    let data = {
      currentChatId: currentChatId,
      platform,
      autochat: !isSwitchOn,
    };
    let response = await dispatch(FBautochat(data));

    //  fetchConversations();

    // dispatch(fetchFBConversations());
    await setIsSwitchOn(!isSwitchOn); // Toggle the switch state
  };

  <FsLightbox
    toggler={imageController.toggler}
    sources={[Showimg]}
  // slide={imageController.slide}
  />;
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target)
      ) {
        setShowEmojiPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleEmojiClick = (emojiObject) => {
    setNewMessage((prevMessage) => prevMessage + emojiObject.emoji);
    setTimeout(() => {
      inputRef.current?.focus();
      const length = inputRef.current.value.length;
      inputRef.current.setSelectionRange(length, length);
    }, 0);
  };
  const fetchTemplateData = (templateId) => {
    dispatch(getTemplatesById(templateId));
    setTemplates(usergetTemplatesFullfill?.template);
  };

  useEffect(() => {
    if (usergetTemplatesFullfill?.template?.length) {

      setTemplates(usergetTemplatesFullfill?.template);
      setSelectedTemplate(usergetTemplatesFullfill?.template[0]);
      fetchTemplateData(usergetTemplatesFullfill?.template[0]?._id);
    }
  }, [usergetTemplatesFullfill]);

  const handleTemplateChange = async (event) => {
    const templateId = event.target.value;
    const selectedTemplate = templates.find(
      (template) => template._id === templateId
    );
    setSelectedTemplate(selectedTemplate);
    if (selectedTemplate) {
      await fetchTemplateData(selectedTemplate._id);
    }
  };
  const filteredChats = chats?.filter((chat) =>
    chat.originalData?.participants?.data[0]?.name
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase())
  );
  const handleDocumentClick = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = url || "file";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const imageOnSlide = (number, item) => {
    setShowimg(item);
    setImageController({
      toggler: !imageController.toggler,
      slide: number,
    });
  }

  return (
    <>
      {
        convLoading ?


          <div
            className="d-flex justify-content-center align-items-center flex-column"
            style={{ height: "100vh" }}
          >
            <Hourglass
              visible={true}
              height="40"
              width="40"
              ariaLabel="color-ring-loading"
              colors={["#50b5ff", "#50b5ff"]}
            />
            <p className="mt-3">Conversation loading, please wait...</p>
          </div>
          :
          <Tab.Container id="left-tabs-example" defaultActiveKey="first">
            <aside
              className="sidebar sidebar-chat sidebar-base border-r border-gray-200/60 bg-white shadow-xl relative overflow-hidden"
              data-sidebar="responsive"
              id="chatsidebar"
            >
              {/* Animated Background Pattern */}
              <div className="absolute inset-0 opacity-5">
                <div className="absolute top-0 left-0 w-32 h-32 bg-gradient-to-br from-[#50B5FF] to-blue-400 rounded-full -translate-x-16 -translate-y-16 animate-pulse"></div>
                <div className="absolute bottom-0 right-0 w-24 h-24 bg-gradient-to-tl from-indigo-400 to-[#50B5FF] rounded-full translate-x-12 translate-y-12 animate-pulse delay-1000"></div>
              </div>

              {/* Header Section */}
              <div className="chat-search relative z-10 pt-6 px-6 bg-gradient-to-br from-[#50B5FF]/8 via-blue-50/50 to-indigo-50/30 backdrop-blur-sm border-b border-gray-100/80">
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center gap-3">
                    <div className="relative">
                      <div className="w-10 h-10 bg-[#50B5FF] via-blue-500 to-indigo-500 rounded-xl flex items-center justify-center">
                        <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                        </svg>
                      </div>

                    </div>
                    <div>
                      <h5 className="text-lg font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">Messages</h5>
                      <p className="text-xs text-gray-500">Stay connected</p>
                    </div>
                  </div>

                  <div
                    className="sidebar-toggle lg:hidden p-2.5 hover:bg-white/80 rounded-xl transition-all duration-300 cursor-pointer group backdrop-blur-sm border border-gray-200/50 shadow-sm"
                    data-toggle="sidebar"
                    data-active="true"
                    onClick={minisidebar}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      className="text-white group-hover:text-[#50B5FF] transition-colors"
                    >
                      <path
                        d="M4.25 12.2744L19.25 12.2744"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>

                {/* Enhanced Search Bar with Animation */}
                {/* <div className="chat-searchbar mb-6">
                  <Form.Group className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none z-10">
                      <svg className="w-5 h-5 text-gray-400 group-focus-within:text-[#50B5FF] transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    </div>
                    <input
                      type="text"
                      className="w-full pl-12 pr-4 py-3.5 bg-white/90 backdrop-blur-sm border border-gray-200/80 rounded-2xl focus:outline-none focus:ring-2 focus:ring-[#50B5FF]/50 focus:border-[#50B5FF] transition-all duration-300 placeholder-gray-500 text-sm shadow-sm hover:shadow-md focus:shadow-lg hover:bg-white"
                      id="chat-search"
                      placeholder="Search conversations, messages..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-[#50B5FF]/10 to-indigo-500/10 opacity-0 group-focus-within:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
                  </Form.Group>
                </div> */}
                <div className="chat-searchbar mb-6">
                  <Form.Group className="relative group">
                    <input
                      type="text"
                      className="w-full pr-12 pl-4 py-3.5 bg-white/90 backdrop-blur-sm border border-gray-200/80 rounded-2xl focus:outline-none focus:ring-2 focus:ring-[#50B5FF]/50 focus:border-[#50B5FF] transition-all duration-300 placeholder-gray-500 text-sm shadow-sm hover:shadow-md focus:shadow-lg hover:bg-white"
                      id="chat-search"
                      placeholder="Search conversations, messages..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />

                    {/* SVG moved to right */}
                    <div className="absolute inset-y-0 right-0 pr-4 flex items-center pointer-events-none z-10">
                      <svg className="w-5 h-5 text-gray-400 group-focus-within:text-[#50B5FF] transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    </div>

                    <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-[#50B5FF]/10 to-indigo-500/10 opacity-0 group-focus-within:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
                  </Form.Group>
                </div>
              </div>

              {/* Chat List with Custom Scrollbar */}
              <div
                className="sidebar-body flex-1 px-4 py-2 overflow-y-auto custom-scrollbar"
                tabIndex="-1"
                style={{
                  outline: "none",
                  maxHeight: "calc(100vh - 230px)"
                }}
              >
                <style jsx>{`
                  .custom-scrollbar::-webkit-scrollbar {
                    width: 6px;
                  }
                  .custom-scrollbar::-webkit-scrollbar-track {
                    background: transparent;
                    border-radius: 10px;
                  }
                  .custom-scrollbar::-webkit-scrollbar-thumb {
                    background:  '#50B5FF';
                    border-radius: 10px;
                    opacity: 0.7;
                  }
                  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                    opacity: 1;
                  }
                  .chat-item {
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                  }
                  .chat-item:hover {
                    transform: translateX(4px);
                  }
                `}</style>

                <div className="scroll-content">
                  <ul
                    className="nav flex-col space-y-2 mt-2"
                    id="sidebar-menu"
                    role="tablist"
                  >
                    <div className="px-3 my-4 flex items-center justify-between">
                      <h6 className="text-xs uppercase tracking-wider text-gray-500 font-bold">Recent Conversations</h6>
                      <div className="w-8 h-0.5 bg-gradient-to-r from-[#50B5FF] to-transparent rounded-full"></div>
                    </div>

                    {filteredChats?.map((chat, index) => {
                      const messageDate = new Date(chat?.originalData?.LastMessageTime);
                      const unreadCount = chat?.originalData?.unreadCount || 0;
                      const formattedTime = messageDate.toLocaleTimeString(
                        "en-US",
                        { hour: "2-digit", minute: "2-digit" }
                      );
                      const isActive = currentChatId === chat?.originalData?.id;

                      return (
                        <Nav.Item
                          key={index}
                          as="li"
                          className="mb-2"
                          role="presentation"
                        >
                          <Nav.Link
                            className={`chat-item flex items-center gap-3 rounded-2xl transition-all duration-300 group cursor-pointer border-0 relative overflow-hidden
                              ${isActive
                                ? "bg-[#50B5FF] text-white"
                                : "text-gray-800 hover:bg-gradient-to-r hover:from-gray-50 hover:to-blue-50/30 group-hover:text-gray-900"
                              }`}
                            eventKey="first"
                            onClick={() => handleChatSelect(chat)}
                          >
                            {/* Animated Background for Active Chat */}
                            {/* {isActive && (
                              <div className="absolute inset-0 bg-gradient-to-r from-[#50B5FF]/5 to-transparent animate-pulse"></div>
                            )} */}

                            {/* Avatar with Enhanced Platform Badge */}
                            <div className="relative flex-shrink-0 z-10">
                              <div className={`w-14 h-14 rounded-2xl overflow-hidden ring-2 transition-all duration-300 group-hover:ring-4 `}>
                                <img
                                  src={user1 || "defaultProfilePic.jpg"}
                                  alt="User Avatar"
                                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                                  loading="lazy"
                                />
                              </div>

                              {/* Enhanced Platform Badge */}
                              <div className="absolute -bottom-1 -right-1 w-7 h-7 rounded-xl bg-white flex items-center justify-center border-2 border-white">
                                {chat?.platform === "facebook" && (
                                  <FaFacebook className="w-4 h-4 text-blue-600 drop-shadow-sm" />
                                )}
                                {chat?.platform === "instagram" && (
                                  <FaInstagram className="w-4 h-4 text-pink-500 drop-shadow-sm" />
                                )}
                                {chat?.platform === "whatsapp" && (
                                  <FaWhatsapp className="w-4 h-4 text-green-500 drop-shadow-sm" />
                                )}
                              </div>

                              {/* Online Status Indicator */}
                            </div>

                            {/* Chat Info with Enhanced Typography */}
                            <div className="flex-1 min-w-0 z-10">
                              <div className="flex items-center justify-between mb-2">
                                <h6 className={`text-sm font-bold truncate transition-colors duration-200 ${isActive
                                  ? "text-white"
                                  : "text-gray-800 group-hover:text-gray-900"
                                  }`}>
                                  {chat?.originalData?.participants?.data[0]?.name || "Unknown User"}
                                </h6>
                                <span className={`text-xs flex-shrink-0 ml-2 font-medium transition-colors duration-200 ${isActive ? "text-white" : "text-gray-500"
                                  }`}>
                                  {chat?.originalData?.LastMessageTime ? formattedTime : ""}
                                </span>
                              </div>

                              <div className="flex items-center justify-between">
                                <p
                                  className={`text-sm truncate flex-1 mr-3 transition-colors duration-200 
    ${isActive ? "text-white" : "text-gray-600 group-hover:text-gray-700"}`}
                                >
                                    <div className="last-message-preview">
                                      {chat?.originalData?.LastMessage ? (
                                        <span
                                          className={`transition-colors duration-200 ${
                                            isActive ? 'text-white' : 'text-gray-400 group-hover:text-gray-900'
                                          }`}
                                          style={{
                                            display: 'block',
                                            maxWidth: '200px', // Adjust based on sidebar width
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                          }}
                                        >
                                          {chat.originalData.LastMessage}
                                        </span>
                                      ) : (
                                        <span
                                          className={`italic transition-colors duration-200 ${
                                            isActive ? 'text-white' : 'text-gray-400 group-hover:text-gray-900'
                                          }`}
                                        >
                                          No messages yet
                                        </span>
                                      )}
                                    </div>
                                </p>

                                {unreadCount > 0 && (
                                  <div className="flex-shrink-0 min-w-[22px] h-6 bg-gradient-to-r from-[#50B5FF] to-blue-500 text-white rounded-full flex items-center justify-center text-xs font-bold">
                                    {unreadCount > 99 ? "99+" : unreadCount}
                                  </div>
                                )}
                              </div>

                              {/* Message Preview Dots */}
                              {/* <div className="flex items-center gap-1 mt-2 opacity-60">
                                <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
                                <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
                                <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
                              </div> */}
                            </div>

                            {/* Hover Arrow */}
                            <div className={`w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ${isActive
                              ? "bg-[#50B5FF]/20 text-[#50B5FF]"
                              : "bg-transparent text-gray-400 group-hover:bg-gray-100 group-hover:text-gray-600"
                              } opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0`}>
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                              </svg>
                            </div>
                          </Nav.Link>
                        </Nav.Item>
                      );
                    })}

                    {/* Empty State */}
                    {filteredChats?.length === 0 && (
                      <div className="text-center py-[245px] px-4">
                        <div className="w-16 h-16 bg-gradient-to-r from-[#50B5FF]/20 to-blue-400/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                          <svg className="w-8 h-8 text-[#50B5FF]/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                          </svg>
                        </div>
                        <h3 className="text-sm font-semibold text-gray-700 mb-1">No conversations</h3>
                        <p className="text-xs text-gray-500">Start a new conversation to see it here</p>
                      </div>
                    )}
                  </ul>
                </div>
              </div>

              {/* Enhanced Footer with Gradient */}
              {/* <div className="sidebar-footer absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-white via-white/95 to-transparent pointer-events-none z-10"></div> */}
            </aside>
            <main className="main-content">
              <div className="container-fluid content-inner p-0" id="page_layout">
                <Tab.Content id="myTabContent">
                  <Tab.Pane
                    eventKey="first"
                    className="card mb-0 fade position-relative overflow-hidden"
                    id="user-content-101"
                    role="tabpanel"
                    style={{
                      background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
                      borderRadius: '24px',
                      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                    }}
                  >
                    {/* Enhanced Header with Gradient Background */}
                    <div className="chat-head position-absolute top-0 w-100 chat-nav z-3">
                      <header
                        className="d-flex justify-content-between align-items-center pt-3 ps-3 pe-3 pb-3"
                        style={{
                          background: 'linear-gradient(135deg, rgba(80, 181, 255, 0.05) 0%, rgba(59, 130, 246, 0.05) 100%)',
                          backdropFilter: 'blur(10px)',
                          borderBottom: '1px solid rgba(80, 181, 255, 0.1)',
                          boxShadow: '0 2px 20px rgba(80, 181, 255, 0.08)',
                          borderRadius: '24px 24px 0 0'
                        }}
                      >
                        {/* Left Section - User Info */}
                        <div className="d-flex align-items-center gap-3">
                          <div className="d-block d-xl-none">
                            <button
                              className="btn btn-sm rounded-3 border-0 d-flex align-items-center justify-content-center"
                              data-toggle="sidebar"
                              data-active="true"
                              onClick={minisidebar}
                              style={{
                                // background: 'linear-gradient(135deg, #50B5FF, #3b82f6)',
                                background:  '#50B5FF',
                                color: 'white',
                                width: '40px',
                                height: '40px',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 4px 12px rgba(80, 181, 255, 0.3)'
                              }}
                            >
                              <svg className="icon-rtl" width="18px" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                              </svg>
                            </button>
                          </div>

                          {/* Enhanced Avatar */}
                          <div className="avatar chat-user-profile m-0 position-relative">
                            <div className="position-relative">
                              <img
                                src={user1}
                                alt="avatar"
                                className="rounded-3 object-cover"
                                loading="lazy"
                                style={{
                                  width: '50px',
                                  height: '50px',
                                  border: '3px solid rgba(80, 181, 255, 0.2)',
                                  transition: 'all 0.3s ease'
                                }}
                              />
                              {/* <div
                                className="position-absolute rounded-circle"
                                style={{
                                  width: '14px',
                                  height: '14px',
                                  background: 'linear-gradient(135deg, #10b981, #059669)',
                                  bottom: '-2px',
                                  right: '-2px',
                                  border: '2px solid white',
                                  boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)'
                                }}
                              /> */}
                            </div>
                          </div>

                          {/* User Name with Enhanced Typography */}
                          <div>
                            <h5
                              className="mb-1 fw-bold"
                              style={{
                                color: '#1e293b',
                                fontSize: '1.1rem',
                                background: 'linear-gradient(135deg, #1e293b, #475569)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent'
                              }}
                            >
                              {messageNavbar?.participants?.data[0]?.name}
                            </h5>
                            {/* <small className="text-muted fw-500 d-flex align-items-center gap-1">
                              <div
                                className="rounded-circle"
                                style={{
                                  width: '6px',
                                  height: '6px',
                                  background: '#10b981'
                                }}
                              />
                              Active now
                            </small> */}
                          </div>
                        </div>

                        {/* Right Section - Controls */}
                        <div className="chat-header-icons d-flex align-items-center gap-3">
                          <div
                            className="d-flex align-items-center gap-2 px-3 py-2 rounded-3"
                            style={{
                              background: 'rgba(80, 181, 255, 0.1)',
                              border: '1px solid rgba(80, 181, 255, 0.2)',
                              backdropFilter: 'blur(10px)'
                            }}
                          >
                            <span className="fw-600 text-dark" style={{ fontSize: '0.9rem' }}>
                              Autochat
                            </span>
                            <Form.Check
                              type="switch"
                              id="custom-switch"
                              className="m-0"
                              checked={isSwitchOn}
                              onChange={handleSwitchChange}
                              style={{
                                '--bs-form-switch-bg': '#50B5FF'
                              }}
                            />
                          </div>

                          <Dropdown className="d-flex align-items-center justify-content-center">
                            <Dropdown.Toggle
                              as="div"
                              bsPrefix=""
                              className="d-flex align-items-center justify-content-center rounded-3 cursor-pointer"
                              id="dropdownMenuButton-09"
                              style={{
                                width: '40px',
                                height: '40px',
                                background: 'rgba(80, 181, 255, 0.1)',
                                border: '1px solid rgba(80, 181, 255, 0.2)',
                                color: '#50B5FF',
                                transition: 'all 0.3s ease'
                              }}
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                              >
                                <circle cx="12" cy="12" r="1" />
                                <circle cx="12" cy="5" r="1" />
                                <circle cx="12" cy="19" r="1" />
                              </svg>
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                              className="dropdown-menu-end shadow-lg border-0 rounded-3"
                              style={{
                                background: 'rgba(255, 255, 255, 0.95)',
                                backdropFilter: 'blur(20px)',
                                border: '1px solid rgba(80, 181, 255, 0.1)',
                                marginTop: '8px'
                              }}
                            >
                              <Dropdown.Item
                                className="d-flex align-items-center gap-2 px-3 py-2 rounded-2 mx-2 my-1"
                                href="#"
                                onClick={handleOpenScheduleModal}
                                style={{
                                  transition: 'all 0.2s ease',
                                  border: 'none'
                                }}
                              >
                                <i
                                  className="material-symbols-outlined"
                                  style={{ fontSize: '18px', color: '#50B5FF' }}
                                >
                                  schedule
                                </i>
                                <span style={{ fontSize: '0.9rem', color: '#374151' }}>
                                  Schedule message
                                </span>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>

                          <ScheduleMessageModal
                            show={showScheduleModal}
                            handleClose={handleCloseScheduleModal}
                            currentChatId={currentChatId}
                            receiverId={senderId}
                            platform={platform}
                            userName={userName}
                            hasUserMessages={hasUserMessages}
                            lastUserMessageDate={lastUserMessageDate}
                          />
                        </div>
                      </header>
                    </div>

                    {/* Chat Body */}
                    {chatLoader ? (
                      <div
                        className="d-flex justify-content-center align-items-center flex-column"
                        style={{ height: "100vh" }}
                      >
                        <Hourglass
                          visible={true}
                          height="40"
                          width="40"
                          ariaLabel="color-ring-loading"
                          colors={["#50b5ff", "#50b5ff"]}
                        />
                        <p className="mt-3">Conversation loading, please wait...</p>
                      </div>
                    ) : (
                      <>
                        {Loader === false ? (
                          <div
                            className="card-body chat-body overflow-auto"
                            ref={sectionRef}
                            onScroll={handleScroll}
                            style={{
                              background: 'transparent',
                              paddingTop: '100px',
                              maxHeight: 'calc(100vh - 180px)',
                              scrollbarWidth: 'thin',
                              scrollbarColor: '#50B5FF rgba(80, 181, 255, 0.1)'
                            }}
                          >
                            <style jsx>{`
                      .chat-body::-webkit-scrollbar {
                        width: 6px;
                      }
                      .chat-body::-webkit-scrollbar-track {
                        background: rgba(80, 181, 255, 0.05);
                        border-radius: 10px;
                      }
                      .chat-body::-webkit-scrollbar-thumb {
                        
                        background:  '#50B5FF';
                        border-radius: 10px;
                        transition: all 0.3s ease;
                      }
                      .chat-body::-webkit-scrollbar-thumb:hover {
                        background: linear-gradient(135deg, #3b82f6, #2563eb);
                      }
                      .chat-day-title {
                        text-align: center;
                        margin: 20px 0;
                        position: relative;
                      }
                      .chat-day-title::before {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 0;
                        right: 0;
                        height: 1px;
                        background: linear-gradient(
                          90deg,
                          transparent,
                          rgba(80, 181, 255, 0.2),
                          transparent
                        );
                      }
                      .chat-day-title .main-title {
                          background: #e7e7e747;
                          color: black;
                          padding: 6px 16px;
                          border-radius: 20px;
                          font-size: 0.75rem;
                          font-weight: 300;
                          position: relative;
                          box-shadow: 0 2px 8px rgb(117 117 117 / 30%);
                      }
                      .iq-message-body {
                        
                        display: flex;
                        gap: 12px;
                        align-items: flex-end;
                        animation: fadeInUp 0.3s ease;
                      }
                      @keyframes fadeInUp {
                        from {
                          opacity: 0;
                          transform: translateY(20px);
                        }
                        to {
                          opacity: 1;
                          transform: translateY(0);
                        }
                      }
                      .iq-current-user {
                        flex-direction: row-reverse;
                        margin-left: auto;
                        max-width: 75%;
                      }
                      .iq-other-user {
                        flex-direction: row;
                        margin-right: auto;
                        max-width: 75%;
                      }
                      .chat-profile {
                        flex-shrink: 0;
                      }
                      .chat-profile img {
                        width: 36px;
                        height: 36px;
                        border: 2px solid rgba(80, 181, 255, 0.1);
                        border-radius: 12px;
                        transition: all 0.3s ease;
                      }
                      .iq-current-user .chat-profile img {
                        border-color: rgba(80, 181, 255, 0.3);
                      }
                      .chat-profile small {
                        font-size: 0.7rem;
                        color: #64748b;
                        margin-top: 4px;
                        font-weight: 500;
                        text-align: center;
                        display: block;
                      }
                      .iq-chat-text {
                        flex: 1;
                        min-width: 0;
                        position: relative;
                      }
                      .iq-chating-content {
                        background: white;
                        border-radius: 18px;
                        position: relative;
                        border: 1px solid rgba(226, 232, 240, 0.8);
                        transition: all 0.3s ease;
                        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
                      }
                      .iq-current-user .iq-chating-content {
                        background:  #50B5FF;
                        color: white;
                        border-color: rgba(80, 181, 255, 0.3);
                        box-shadow: 0 4px 12px rgba(80, 181, 255, 0.2);
                        border-radius: 18px 18px 6px 18px;
                      }
                      .iq-other-user .iq-chating-content {
                        background: white;
                        color: #374151;
                        border-radius: 18px 18px 18px 6px;
                      }
                      .iq-chating-content p {
                        margin: 0;
                        line-height: 1.4;
                        font-size: 0.9rem;
                        word-wrap: break-word;
                      }
                      .photo-imgsize {
                        max-width: 250px;
                        max-height: 300px;
                        border-radius: 12px;
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                        transition: transform 0.3s ease;
                      }
                      .photo-imgsize:hover {
                        transform: scale(1.02);
                      }
                      .dropdown-toggle::after {
                        display: none !important;
                      }
                      .more .dropdown-toggle {
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        background: rgba(107, 114, 128, 0.1);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        transition: all 0.3s ease;
                        opacity: 0;
                        position: absolute;
                        top: -16px;
                        right: -16px;
                      }
                      .iq-other-user .more .dropdown-toggle {
                        left: -16px;
                        right: auto;
                      }
                      .iq-message-body:hover .more .dropdown-toggle {
                        opacity: 1;
                      }
                      .more .dropdown-toggle:hover {
                        background: rgba(80, 181, 255, 0.1);
                        color: #50B5FF;
                      }
                      .more .dropdown-menu {
                        border: none;
                        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
                        border-radius: 12px;
                        background: rgba(255, 255, 255, 0.95);
                        backdrop-filter: blur(20px);
                        min-width: 180px;
                      }
                      .more .dropdown-item {
                        padding: 8px 16px;
                        border-radius: 8px;
                        margin: 4px 8px;
                        transition: all 0.2s ease;
                        font-size: 0.85rem;
                        display: flex;
                        align-items: center;
                        gap: 8px;
                      }
                      .more .dropdown-item:hover {
                        background: rgba(80, 181, 255, 0.1);
                        color: #50B5FF;
                      }
                      .audio-player audio {
                        max-width: 250px;
                        height: 40px;
                        border-radius: 8px;
                      }
                      .audio-player .rhap_container {
                        background: transparent;
                        box-shadow: none;
                        padding: 0;
                      }
                    `}</style>

                            {isLoading && (
                              <div className="text-center py-4">
                                <div className="d-inline-block p-3 rounded-2xl bg-white/50 backdrop-blur-sm">
                                  <p className="text-[#50B5FF] font-medium mb-0">Loading messages...</p>
                                </div>
                              </div>
                            )}

                            {messages?.map((msg, index) => {
                              const messageDate = new Date(msg.created_time);
                              const formattedTime = messageDate.toLocaleTimeString('en-US', {
                                hour: '2-digit',
                                minute: '2-digit'
                              });
                              const formattedDate = messageDate.toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric'
                              });
                              const showDate =
                                index === 0 ||
                                new Date(messages[index - 1]?.created_time).toDateString() !==
                                messageDate.toDateString();

                              const shareLink = msg?.shares?.data?.[0]?.link;
                              const shareType = msg?.shares?.data?.[0]?.type;
                              const hasImage = msg?.attachments?.data?.[0]?.image_data?.url;
                              const hasVideo = msg?.attachments?.data?.[0]?.video_data?.url;
                              const hasDocumentName = msg?.attachments?.data?.[0]?.name;
                              const hasDocumentUrl = msg?.attachments?.data?.[0]?.file_url;
                              const hasAudioUrl = msg?.attachments?.data?.[0]?.audio_data;
                              const googleMeetUrlRegex = /(https?:\/\/meet\.google\.com\/[a-zA-Z0-9-]+)/;
                              const googleMeetUrlMatch = msg?.message?.match(googleMeetUrlRegex);
                              const hasGooglemeetUrl = googleMeetUrlMatch ? googleMeetUrlMatch[0] : '';

                              if (msg?.from?.id === instagramAccountId) {
                                return (
                                  <React.Fragment key={msg.id}>
                                    {showDate && (
                                      <div className="chat-day-title">
                                        <span className="main-title">{formattedDate}</span>
                                      </div>
                                    )}
                                    <div className="iq-message-body iq-current-user">
                                      <div className="chat-profile text-center">
                                        <img
                                          src={user1}
                                          alt="chat-user"
                                          className="rounded-3 object-cover"
                                          loading="lazy"
                                        />
                                        <small className="d-block mt-1">{formattedTime}</small>
                                      </div>
                                      <div className="iq-chat-text">
                                        <div className="d-flex align-items-center justify-content-end gap-4">
                                          {(msg.message ||
                                            hasImage ||
                                            shareLink ||
                                            hasVideo ||
                                            hasAudioUrl ||
                                            hasDocumentUrl) && (
                                              <Dropdown className="dropdown cursor-pointer more">
                                                <Dropdown.Toggle className="lh-1" id="post-option" as="span" bsPrefix="">
                                                  <span className="material-symbols-outlined">more_vert</span>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                  {msg?.message && (
                                                    <Dropdown.Item
                                                      href="#"
                                                      onClick={() => handleCopy(msg?.message)}
                                                    >
                                                      <span className="material-symbols-outlined">content_copy</span>
                                                      Copy message
                                                    </Dropdown.Item>
                                                  )}
                                                  {hasImage && (
                                                    <Dropdown.Item
                                                      href="#"
                                                      onClick={() => handleDownload(hasImage, 'image.jpg')}
                                                    >
                                                      <span className="material-symbols-outlined">download</span>
                                                      Download Image
                                                    </Dropdown.Item>
                                                  )}
                                                  {shareLink && shareType?.startsWith('image') && (
                                                    <Dropdown.Item
                                                      href="#"
                                                      onClick={() => handleDownload(shareLink, 'shared-image.jpg')}
                                                    >
                                                      <span className="material-symbols-outlined">download</span>
                                                      Download Image
                                                    </Dropdown.Item>
                                                  )}
                                                  {shareLink && shareType?.startsWith('video') && (
                                                    <Dropdown.Item
                                                      href="#"
                                                      onClick={() => handleDownload(shareLink, 'shared-video.mp4')}
                                                    >
                                                      <span className="material-symbols-outlined">download</span>
                                                      Download Video
                                                    </Dropdown.Item>
                                                  )}
                                                  {hasVideo && (
                                                    <Dropdown.Item
                                                      href="#"
                                                      onClick={() => handleDownload(hasVideo, 'video.mp4')}
                                                    >
                                                      <span className="material-symbols-outlined">download</span>
                                                      Download Video
                                                    </Dropdown.Item>
                                                  )}
                                                  {hasAudioUrl && (
                                                    <Dropdown.Item
                                                      href="#"
                                                      onClick={() => handleDownload(hasAudioUrl.url, 'audio.mp3')}
                                                    >
                                                      <span className="material-symbols-outlined">download</span>
                                                      Download Audio
                                                    </Dropdown.Item>
                                                  )}
                                                  {hasDocumentUrl && (
                                                    <>
                                                      <Dropdown.Item
                                                        href="#"
                                                        onClick={() => window.open(hasDocumentUrl, '_blank')}
                                                      >
                                                        <span className="material-symbols-outlined">visibility</span>
                                                        View Document
                                                      </Dropdown.Item>
                                                      <Dropdown.Item
                                                        href="#"
                                                        onClick={() => handleDownload(hasDocumentUrl, hasDocumentName)}
                                                      >
                                                        <span className="material-symbols-outlined">download</span>
                                                        Download Document
                                                      </Dropdown.Item>
                                                    </>
                                                  )}
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            )}

                                          <div
                                            className={
                                              hasImage ||
                                                shareLink ||
                                                hasVideo ||
                                                hasAudioUrl ||
                                                hasDocumentUrl ||
                                                hasGooglemeetUrl
                                                ? `d-flex align-items-center`
                                                : `iq-chating-content d-flex align-items-center`
                                            }
                                          >
                                            {hasImage && (
                                              <div>
                                                <a
                                                  data-fancybox="gallery"
                                                  data-src={hasImage}
                                                  data-caption="Shared Image"
                                                  href={hasImage}
                                                >
                                                  <img
                                                    loading="lazy"
                                                    src={hasImage}
                                                    alt="gallery"
                                                    className="img-fluid photo-imgsize"
                                                    style={{ cursor: 'pointer' }}
                                                  />
                                                </a>
                                              </div>
                                            )}

                                            {shareLink && shareType && (
                                              <div>
                                                {shareType.startsWith('image') ? (
                                                  <a
                                                    data-fancybox="gallery"
                                                    data-src={shareLink}
                                                    data-caption="Shared Image"
                                                    href={shareLink}
                                                  >
                                                    <img
                                                      src={shareLink}
                                                      alt="Shared attachment"
                                                      className="photo-imgsize"
                                                      style={{ cursor: 'pointer' }}
                                                    />
                                                  </a>
                                                ) : shareType.startsWith('video') ? (
                                                  <video src={shareLink} controls className="photo-imgsize">
                                                    Your browser does not support the video tag.
                                                  </video>
                                                ) : null}
                                              </div>
                                            )}

                                            {hasVideo && (
                                              <iframe
                                                title="myFrame"
                                                className="rounded photo-imgsize"
                                                src={hasVideo}
                                                allowFullScreen
                                                frameBorder="0"
                                                scrolling="no"
                                                allowtransparency="true"
                                                allow="encrypted-media"
                                                width="320"
                                                height="240"
                                              ></iframe>
                                            )}

                                            {hasAudioUrl && (
                                              <div className="audio-player">
                                                <AudioPlayer
                                                  src={hasAudioUrl.url}
                                                  onPlay={(e) => console.log('onPlay')}
                                                  style={{ borderRadius: '8px' }}
                                                />
                                              </div>
                                            )}

                                            {hasDocumentUrl && hasDocumentName && (
                                              <div
                                                className="bg-light border rounded-3 p-3"
                                                style={{ maxWidth: '250px' }}
                                              >
                                                <div className="d-flex align-items-center justify-content-between">
                                                  <div className="d-flex align-items-center flex-grow-1">
                                                    <span className="me-2 fs-4">{getFileIcon(hasDocumentName)}</span>
                                                    <div className="flex-grow-1">
                                                      <div
                                                        className="fw-semibold text-truncate"
                                                        style={{ maxWidth: '150px' }}
                                                      >
                                                        {hasDocumentName}
                                                      </div>
                                                      <small className="text-muted">
                                                        {getFileExtension(hasDocumentName).toUpperCase()}
                                                      </small>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )}

                                            {hasGooglemeetUrl && (
                                              <div className="d-flex align-items-center">
                                                <a
                                                  href={hasGooglemeetUrl}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  className="btn d-flex align-items-center gap-2 rounded-3"
                                                  style={{
                                                    // background: 'linear-gradient(135deg, #50B5FF)',
                                                                 background:  '#50B5FF',
                                                    color: 'white',
                                                    border: 'none',
                                                    padding: '8px 16px'
                                                  }}
                                                >
                                                  <FaVideo />
                                                  <span>Join Google Meet</span>
                                                </a>
                                              </div>
                                            )}

                                            {!hasImage &&
                                              !shareLink &&
                                              !hasVideo &&
                                              !hasAudioUrl &&
                                              !hasDocumentUrl &&
                                              !hasGooglemeetUrl &&
                                              
                                              <p className="mb-0" style={{ maxWidth: '100%', wordBreak: 'break-word' }}>
                    {msg?.message}
                  </p>
                                              }
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </React.Fragment>
                                );
                              } else {
                                return (
                                  <React.Fragment key={msg.id}>
                                    {showDate && (
                                      <div className="chat-day-title">
                                        <span className="main-title">{formattedDate}</span>
                                      </div>
                                    )}
                                    <div className="iq-message-body iq-other-user">
                                      <div className="chat-profile text-center">
                                        <img
                                          src={user1}
                                          alt="chat-user"
                                          className="rounded-3 object-cover"
                                          loading="lazy"
                                        />
                                        <small className="d-block mt-1">{formattedTime}</small>
                                      </div>
                                      <div className="iq-chat-text">
                                        <div className="d-flex align-items-center justify-content-start gap-4">
                                          <div
                                            className={
                                              hasImage ||
                                                shareLink ||
                                                hasVideo ||
                                                hasAudioUrl ||
                                                hasDocumentUrl ||
                                                hasGooglemeetUrl
                                                ? `d-flex align-items-center`
                                                : `iq-chating-content d-flex align-items-center`
                                            }
                                          >
                                            {hasImage && (
                                              <div>
                                                <a
                                                  data-fancybox="gallery"
                                                  data-src={hasImage}
                                                  data-caption="Shared Image"
                                                  href={hasImage}
                                                >
                                                  <img
                                                    loading="lazy"
                                                    src={hasImage}
                                                    alt="gallery"
                                                    className="img-fluid photo-imgsize"
                                                    style={{ cursor: 'pointer' }}
                                                  />
                                                </a>
                                              </div>
                                            )}

                                            {shareLink && shareType && (
                                              <div>
                                                {shareType.startsWith('image') ? (
                                                  <a
                                                    data-fancybox="gallery"
                                                    data-src={shareLink}
                                                    data-caption="Shared Image"
                                                    href={shareLink}
                                                  >
                                                    <img
                                                      src={shareLink}
                                                      alt="Shared attachment"
                                                      className="photo-imgsize"
                                                      style={{ cursor: 'pointer' }}
                                                    />
                                                  </a>
                                                ) : shareType.startsWith('video') ? (
                                                  <video src={shareLink} controls className="photo-imgsize">
                                                    Your browser does not support the video tag.
                                                  </video>
                                                ) : null}
                                              </div>
                                            )}

                                            {hasVideo && (
                                              <iframe
                                                title="myFrame"
                                                className="rounded photo-imgsize"
                                                src={hasVideo}
                                                allowFullScreen
                                                frameBorder="0"
                                                scrolling="no"
                                                allowtransparency="true"
                                                allow="encrypted-media"
                                                width="320"
                                                height="240"
                                              ></iframe>
                                            )}

                                            {hasAudioUrl && (
                                              <div className="audio-player">
                                                <AudioPlayer
                                                  src={hasAudioUrl.url}
                                                  onPlay={(e) => console.log('onPlay')}
                                                  style={{ borderRadius: '8px' }}
                                                />
                                              </div>
                                            )}

                                            {hasDocumentUrl && hasDocumentName && (
                                              <div
                                                className="bg-light border rounded-3 p-3"
                                                style={{ maxWidth: '250px' }}
                                              >
                                                <div className="d-flex align-items-center justify-content-between">
                                                  <div className="d-flex align-items-center flex-grow-1">
                                                    <span className="me-2 fs-4">{getFileIcon(hasDocumentName)}</span>
                                                    <div className="flex-grow-1">
                                                      <div
                                                        className="fw-semibold text-truncate"
                                                        style={{ maxWidth: '150px' }}
                                                      >
                                                        {hasDocumentName}
                                                      </div>
                                                      <small className="text-muted">
                                                        {getFileExtension(hasDocumentName).toUpperCase()}
                                                      </small>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )}

                                            {hasGooglemeetUrl && (
                                              <div className="d-flex align-items-center">
                                                <a
                                                  href={hasGooglemeetUrl}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  className="btn d-flex align-items-center gap-2 rounded-3"
                                                  style={{
                                                    // background: 'linear-gradient(135deg, #50B5FF, #3b82f6)',
                                                    background:  '#50B5FF',
                                                    color: 'white',
                                                    border: 'none',
                                                    padding: '8px 16px'
                                                  }}
                                                >
                                                  <FaVideo />
                                                  <span>Join Google Meet</span>
                                                </a>
                                              </div>
                                            )}

                                            {!hasImage &&
                                              !shareLink &&
                                              !hasVideo &&
                                              !hasAudioUrl &&
                                              !hasDocumentUrl &&
                                              !hasGooglemeetUrl && 
                                                   <p className="mb-0" style={{ maxWidth: '100%', wordBreak: 'break-word' }}>
                    {msg?.message}
                  </p>
                                              }
                                          </div>

                                          {(msg.message ||
                                            hasImage ||
                                            shareLink ||
                                            hasVideo ||
                                            hasAudioUrl ||
                                            hasDocumentUrl) && (
                                              <Dropdown className="dropdown cursor-pointer more">
                                                <Dropdown.Toggle className="lh-1" id="post-option" as="span" bsPrefix="">
                                                  <span className="material-symbols-outlined">more_vert</span>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                  {msg?.message && (
                                                    <Dropdown.Item
                                                      href="#"
                                                      onClick={() => handleCopy(msg?.message)}
                                                    >
                                                      <span className="material-symbols-outlined">content_copy</span>
                                                      Copy message
                                                    </Dropdown.Item>
                                                  )}
                                                  {hasImage && (
                                                    <Dropdown.Item
                                                      href="#"
                                                      onClick={() => handleDownload(hasImage, 'image.jpg')}
                                                    >
                                                      <span className="material-symbols-outlined">download</span>
                                                      Download Image
                                                    </Dropdown.Item>
                                                  )}
                                                  {shareLink && shareType?.startsWith('image') && (
                                                    <Dropdown.Item
                                                      href="#"
                                                      onClick={() => handleDownload(shareLink, 'shared-image.jpg')}
                                                    >
                                                      <span className="material-symbols-outlined">download</span>
                                                      Download Image
                                                    </Dropdown.Item>
                                                  )}
                                                  {shareLink && shareType?.startsWith('video') && (
                                                    <Dropdown.Item
                                                      href="#"
                                                      onClick={() => handleDownload(shareLink, 'shared-video.mp4')}
                                                    >
                                                      <span className="material-symbols-outlined">download</span>
                                                      Download Video
                                                    </Dropdown.Item>
                                                  )}
                                                  {hasVideo && (
                                                    <Dropdown.Item
                                                      href="#"
                                                      onClick={() => handleDownload(hasVideo, 'video.mp4')}
                                                    >
                                                      <span className="material-symbols-outlined">download</span>
                                                      Download Video
                                                    </Dropdown.Item>
                                                  )}
                                                  {hasAudioUrl && (
                                                    <Dropdown.Item
                                                      href="#"
                                                      onClick={() => handleDownload(hasAudioUrl.url, 'audio.mp3')}
                                                    >
                                                      <span className="material-symbols-outlined">download</span>
                                                      Download Audio
                                                    </Dropdown.Item>
                                                  )}
                                                  {hasDocumentUrl && (
                                                    <>
                                                      <Dropdown.Item
                                                        href="#"
                                                        onClick={() => window.open(hasDocumentUrl, '_blank')}
                                                      >
                                                        <span className="material-symbols-outlined">visibility</span>
                                                        View Document
                                                      </Dropdown.Item>
                                                      <Dropdown.Item
                                                        href="#"
                                                        onClick={() => handleDownload(hasDocumentUrl, hasDocumentName)}
                                                      >
                                                        <span className="material-symbols-outlined">download</span>
                                                        Download Document
                                                      </Dropdown.Item>
                                                    </>
                                                  )}
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                  </React.Fragment>
                                );
                              }
                            })}
                          </div>
                        ) : (
                          <FsLightbox toggler={imageController.toggler} sources={[Showimg]} />
                        )}
                      </>
                    )}

                    {showEmojiPicker && (
                      <div className="position-absolute left-0 emoji-box" ref={emojiPickerRef}>
                        <EmojiPicker onEmojiClick={handleEmojiClick} />
                      </div>
                    )}
                    {showquickreply && (
                      <div
                        className="position-absolute emoji-box"
                        style={{
                          left: '0',
                          bottom: '60px',
                          backgroundColor: 'white',
                          color: '#fff',
                          width: '100%',
                          maxWidth: '350px',
                          borderRadius: '10px',
                          padding: '20px 10px',
                          boxShadow: 'rgb(215 215 215 / 50%) 0px 2',
                          zIndex: 1000
                        }}
                      >
                        <Row className="mb-2 px-2">
                          <Col>
                            <span className="text-black" style={{ fontSize: '1rem' }}>
                              Quick Replies
                            </span>
                          </Col>
                        </Row>

                        <ListGroup variant="flush">
                          {filteredQuickReplies?.map((item, index) => (
                            <ListGroup.Item
                              key={index}
                              className="bg-transparent text-light border-0 py-2 border-bottom"
                              onClick={() => handleQuickReplies(item.payload)}
                            >
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <span className="text-black" style={{ fontSize: '0.85rem' }}>
                                    {item.title}
                                  </span>
                                  <br />
                                  <span className="text-[#a7a7a7]" style={{ fontSize: '0.95rem' }}>
                                    {item.payload || 'No Title'}
                                  </span>
                                </div>
                              </div>
                            </ListGroup.Item>
                          ))}
                        </ListGroup>
                      </div>
                    )}

                    {Loader === false && (
                      <div
                        className={`card-footer ${hasUserMessages === false ? 'px-3 py-3' : 'px-3 py-3'
                          } border-top rounded-0`}
                        style={{
                          background: 'rgba(255, 255, 255, 0.95)',
                          backdropFilter: 'blur(10px)',
                          borderTop: '1px solid rgba(80, 181, 255, 0.1)'
                        }}
                      >
                        <ChatInput
                          platform={platform}
                          hasUserMessages={hasUserMessages}
                          handleShow4={handleShow4}
                          handleClose4={handleClose4}
                          canSendTemplate={canSendTemplate}
                          handleSendMessage={handleSendMessage}
                          senderId={senderId}
                          setNewMessage={setNewMessage}
                          newMessage={newMessage}
                          faqs={faqs}
                          templates={'templates'}
                          fbSendMessageloading={fbSendMessageloading}
                          igSendMessageloading={igSendMessageloading}
                          handleFileUpload={handleFileUpload}
                          setShowEmojiPicker={setShowEmojiPicker}
                          showEmojiPicker={showEmojiPicker}
                          setShowQuickReply={setShowQuickReply}
                          setFilteredQuickReplies={setFilteredQuickReplies}
                          inputRef={inputRef}
                          inputFile={inputFile}
                        />
                      </div>
                    )}
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </main>

            {/* <main className="main-content flex-1 bg-gray-100/50">
              <div className="container-fluid content-inner p-0" id="page_layout">
                <Tab.Content id="myTabContent">
                  <Tab.Pane
                    eventKey="first"
                    className="card mb-0 fade position-relative bg-white rounded-2xl shadow-lg"
                    id="user-content-101"
                    role="tabpanel"
                  >
                    <div className="chat-head sticky top-0 w-full bg-white/90 backdrop-blur-md border-b border-gray-200/50 z-20">
                      <header className="flex justify-between items-center p-4 sm:p-5">
                        <div className="flex items-center gap-3 sm:gap-4">
                          <div className="d-block d-xl-none">
                            <button
                              className="p-2.5 bg-gray-100/50 hover:bg-[#50B5FF]/10 rounded-full transition-all duration-300 ease-in-out"
                              data-toggle="sidebar"
                              data-active="true"
                              onClick={minisidebar}
                            >
                              <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                              </svg>
                            </button>
                          </div>
                          <div className="relative">
                            <img
                              src={user1}
                              alt="avatar"
                              className="w-12 h-12 sm:w-14 sm:h-14 object-cover rounded-full ring-2 ring-[#50B5FF]/20 transition-all duration-300 hover:ring-4"
                              loading="lazy"
                            />
                            <span className="absolute bottom-0 right-0 w-3.5 h-3.5 bg-green-400 rounded-full border-2 border-white shadow-sm"></span>
                          </div>
                          <div>
                            <h5 className="mb-0.5 text-base sm:text-lg font-semibold text-gray-900 tracking-tight">
                              {messageNavbar?.participants?.data[0]?.name}
                            </h5>
                            <small className="text-xs sm:text-sm text-gray-500">Online</small>
                          </div>
                        </div>

                        <div className="flex items-center gap-2 sm:gap-3">
                          <div className="flex items-center bg-[#50B5FF]/10 rounded-full px-3 py-1.5 transition-all duration-300 hover:bg-[#50B5FF]/20">
                            <span className="text-xs sm:text-sm text-gray-700 mr-2 font-medium">Autochat</span>
                            <Form.Check
                              type="switch"
                              id="custom-switch"
                              className="m-0 scale-90 sm:scale-100"
                              checked={isSwitchOn}
                              onChange={handleSwitchChange}
                            />
                          </div>
                          <Dropdown as="span">
                            <Dropdown.Toggle
                              as="span"
                              className="p-2.5 hover:bg-[#50B5FF]/10 rounded-full transition-all duration-300 cursor-pointer"
                              id="dropdownMenuButton-09"
                              data-bs-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              role="menu"
                              width="24"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10 20.6788C10 21.9595 11.0378 23 12.3113 23C13.5868 23 14.6265 21.9595 14.6265 20.6788C14.6265 19.3981 13.5868 18.3576 12.3113 18.3576C11.0378 18.3576 10 19.3981 10 20.6788ZM10 12.0005C10 13.2812 11.0378 14.3217 12.3113 14.3217C13.5868 14.3217 14.6265 13.2812 14.6265 12.0005C14.6265 10.7198 13.5868 9.67929 12.3113 9.67929C11.0378 9.67929 10 10.7198 10 12.0005ZM12.3113 5.64239C11.0378 5.64239 10 4.60192 10 3.3212C10 2.04047 11.0378 1 12.3113 1C13.5868 1 14.6265 2.04047 14.6265 3.3212C14.6265 4.60192 13.5868 5.64239 12.3113 5.64239Z"
                                fill="currentColor"
                              ></path>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="mt-2 bg-white shadow-xl border-0 rounded-lg py-2 min-w-[180px]">
                              <Dropdown.Item
                                className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-[#50B5FF]/10 hover:text-[#50B5FF] transition-all"
                                onClick={handleOpenScheduleModal}
                              >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                Schedule message
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                          <ScheduleMessageModal
                            show={showScheduleModal}
                            handleClose={handleCloseScheduleModal}
                            currentChatId={currentChatId}
                            receiverId={senderId}
                            platform={platform}
                            userName={userName}
                            hasUserMessages={hasUserMessages}
                            lastUserMessageDate={lastUserMessageDate}
                          />
                        </div>
                      </header>
                    </div>

                    {chatLoader ? (
                      <div className="flex justify-center items-center h-[calc(100vh-80px)]">
                        <Hourglass
                          visible={true}
                          height="48"
                          width="48"
                          ariaLabel="color-ring-loading"
                          colors={["#50B5FF", "#3b82f6"]}
                        />
                      </div>
                    ) : (
                      <>
                        {Loader === false ? (
                          <div
                            className="card-body chat-body pt-20 pb-24 px-4 sm:px-6 overflow-y-auto custom-scrollbar"
                            ref={sectionRef}
                            onScroll={handleScroll}
                            style={{ maxHeight: "calc(100vh - 140px)" }}
                          >
                            <style jsx>{`
                  .custom-scrollbar::-webkit-scrollbar {
                    width: 6px;
                  }
                  .custom-scrollbar::-webkit-scrollbar-track {
                    background: transparent;
                    border-radius: 10px;
                  }
                  .custom-scrollbar::-webkit-scrollbar-thumb {
                    background: linear-gradient(135deg, #50B5FF, #3b82f6);
                    border-radius: 10px;
                  }
                  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(135deg, #3b82f6, #50B5FF);
                  }
                  .message-bubble {
                    transition: transform 0.2s ease-in-out;
                  }
                  .message-bubble:hover {
                    transform: translateY(-2px);
                  }
                `}</style>

                            {isLoading && <p className="text-center text-gray-500 text-sm py-4">Loading messages...</p>}
                            {messages?.map((msg, index) => {
                              const messageDate = new Date(msg.created_time);
                              const formattedTime = messageDate.toLocaleTimeString("en-US", {
                                hour: "2-digit",
                                minute: "2-digit",
                              });
                              const formattedDate = messageDate.toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                              });
                              const showDate =
                                index === 0 ||
                                new Date(messages[index - 1]?.created_time).toDateString() !==
                                messageDate.toDateString();

                              const shareLink = msg?.shares?.data?.[0]?.link;
                              const shareType = msg?.shares?.data?.[0]?.type;
                              const hasImage = msg?.attachments?.data?.[0]?.image_data?.url;
                              const hasVideo = msg?.attachments?.data?.[0]?.video_data?.url;
                              const hasDocumentName = msg?.attachments?.data?.[0]?.name;
                              const hasDocumentUrl = msg?.attachments?.data?.[0]?.file_url;
                              const hasAudioUrl = msg?.attachments?.data?.[0]?.audio_data;
                              const googleMeetUrlRegex = /(https?:\/\/meet\.google\.com\/[a-zA-Z0-9-]+)/;
                              const googleMeetUrlMatch = msg?.message?.match(googleMeetUrlRegex);
                              const hasGooglemeetUrl = googleMeetUrlMatch ? googleMeetUrlMatch[0] : "";

                              const isCurrentUser = msg?.from?.id === instagramAccountId;

                              return (
                                <React.Fragment key={msg.id}>
                                  {showDate && (
                                    <div className="chat-day-title text-center my-6">
                                      <span className="inline-block bg-gray-200/80 text-gray-600 text-xs font-medium px-4 py-1.5 rounded-full shadow-sm">
                                        {formattedDate}
                                      </span>
                                    </div>
                                  )}
                                  <div
                                    className={`flex ${isCurrentUser ? "justify-end" : "justify-start"} mb-4 sm:mb-5 message-bubble`}
                                  >
                                    {!isCurrentUser && (
                                      <div className="flex-shrink-0 mr-3 mt-2 hidden sm:block">
                                        <img
                                          src={user1}
                                          alt="chat-user"
                                          className="w-10 h-10 object-cover rounded-full ring-1 ring-gray-200"
                                          loading="lazy"
                                        />
                                      </div>
                                    )}
                                    <div
                                      className={`max-w-[70%] sm:max-w-[60%] md:max-w-[50%] ${isCurrentUser ? "ml-10" : "mr-10"}`}
                                    >
                                      <div
                                        className={`relative p-3 sm:p-4 rounded-2xl shadow-md ${isCurrentUser
                                          ? "bg-gradient-to-br from-[#50B5FF] to-[#3b82f6] text-white"
                                          : "bg-white text-gray-900 border border-gray-200/50"


                                          }`}
                                      >
                                        {hasImage && (
                                          <a
                                            data-fancybox="gallery"
                                            data-src={hasImage}
                                            data-caption="Shared Image"
                                            href={hasImage}
                                            className="block mb-2"
                                          >
                                            <img
                                              loading="lazy"
                                              src={hasImage}
                                              alt="gallery"
                                              className="max-w-full rounded-lg shadow-sm"
                                              style={{ maxHeight: "200px" }}
                                            />
                                          </a>
                                        )}

                                        {shareLink && shareType && (
                                          <div className="mb-2">
                                            {shareType.startsWith("image") ? (
                                              <a
                                                data-fancybox="gallery"
                                                data-src={shareLink}
                                                data-caption="Shared Image"
                                                href={shareLink}
                                                className="block"
                                              >
                                                <img
                                                  src={shareLink}
                                                  alt="Shared attachment"
                                                  className="max-w-full rounded-lg shadow-sm"
                                                  style={{ maxHeight: "200px" }}
                                                />
                                              </a>
                                            ) : shareType.startsWith("video") ? (
                                              <video
                                                src={shareLink}
                                                controls
                                                className="max-w-full rounded-lg shadow-sm"
                                                style={{ maxHeight: "200px" }}
                                              >
                                                Your browser does not support the video tag.
                                              </video>
                                            ) : null}
                                          </div>
                                        )}

                                        {hasVideo && (
                                          <iframe
                                            title="myFrame"
                                            className="w-full rounded-lg shadow-sm"
                                            src={hasVideo}
                                            allowFullScreen
                                            frameBorder="0"
                                            scrolling="no"
                                            allow="encrypted-media"
                                            style={{ maxHeight: "200px" }}
                                          ></iframe>
                                        )}

                                        {hasAudioUrl && (
                                          <audio
                                            controls
                                            className="w-full"
                                            style={{ height: "40px", borderRadius: "8px" }}
                                          >
                                            <source src={hasAudioUrl.url} type="audio/mp3" />
                                            Your browser does not support the audio element.
                                          </audio>
                                        )}

                                        {hasDocumentUrl && hasDocumentName && (
                                          <div className="bg-gray-50 rounded-lg p-3 flex items-center gap-3 shadow-sm">
                                            <span className="text-2xl text-gray-600">{getFileIcon(hasDocumentName)}</span>
                                            <div className="flex-1 min-w-0">
                                              <div className="font-medium text-sm text-gray-800 truncate">
                                                {hasDocumentName}
                                              </div>
                                              <small className="text-gray-500 text-xs">
                                                {getFileExtension(hasDocumentName).toUpperCase()}
                                              </small>
                                            </div>
                                          </div>
                                        )}

                                        {hasGooglemeetUrl && (
                                          <a
                                            href={hasGooglemeetUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="inline-flex items-center gap-2 bg-[#50B5FF] text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-[#3b82f6] transition-all duration-300"
                                          >
                                            <FaVideo className="w-4 h-4" />
                                            Join Google Meet
                                          </a>
                                        )}

                                        {!hasImage &&
                                          !shareLink &&
                                          !hasVideo &&
                                          !hasAudioUrl &&
                                          !hasDocumentUrl &&
                                          !hasGooglemeetUrl && (
                                            <p className="mb-0 text-sm leading-relaxed">{msg?.message}</p>
                                          )}

                                        {(msg.message ||
                                          hasImage ||
                                          shareLink ||
                                          hasVideo ||
                                          hasAudioUrl ||
                                          hasDocumentUrl) && (
                                            <Dropdown className="absolute -top-2 -right-2">
                                              <Dropdown.Toggle
                                                as="span"
                                                className="p-1.5 bg-white rounded-full shadow-sm hover:bg-gray-100 transition-all duration-300 cursor-pointer"
                                                bsPrefix="dropdown-toggle" // This prevents bootstrap from adding caret
                                              >
                                                <svg
                                                  className="w-4 h-4 text-gray-500"
                                                  fill="none"
                                                  stroke="currentColor"
                                                  viewBox="0 0 24 24"
                                                >
                                                  <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M12 5v.01M12 12v.01M12 19v.01"
                                                  />
                                                </svg>
                                              </Dropdown.Toggle>

                                              <Dropdown.Menu className="mt-2 bg-white shadow-xl border-0 rounded-lg py-2 min-w-[180px]">
                                                {msg?.message && (
                                                  <Dropdown.Item
                                                    className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-[#50B5FF]/10 hover:text-[#50B5FF]"
                                                    onClick={() => handleCopy(msg?.message)}
                                                  >
                                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                      <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                                                      />
                                                    </svg>
                                                    Copy message text
                                                  </Dropdown.Item>
                                                )}
                                                {hasImage && (
                                                  <Dropdown.Item
                                                    className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-[#50B5FF]/10 hover:text-[#50B5FF]"
                                                    onClick={() => handleDownload(hasImage, "image.jpg")}
                                                  >
                                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                      <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                                      />
                                                    </svg>
                                                    Download Image
                                                  </Dropdown.Item>
                                                )}
                                                {shareLink && shareType?.startsWith("image") && (
                                                  <Dropdown.Item
                                                    className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-[#50B5FF]/10 hover:text-[#50B5FF]"
                                                    onClick={() => handleDownload(shareLink, "shared-image.jpg")}
                                                  >
                                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                      <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                                      />
                                                    </svg>
                                                    Download Image
                                                  </Dropdown.Item>
                                                )}
                                                {shareLink && shareType?.startsWith("video") && (
                                                  <Dropdown.Item
                                                    className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-[#50B5FF]/10 hover:text-[#50B5FF]"
                                                    onClick={() => handleDownload(shareLink, "shared-video.mp4")}
                                                  >
                                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                      <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                                      />
                                                    </svg>
                                                    Download Video
                                                  </Dropdown.Item>
                                                )}
                                                {hasVideo && (
                                                  <Dropdown.Item
                                                    className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-[#50B5FF]/10 hover:text-[#50B5FF]"
                                                    onClick={() => handleDownload(hasVideo, "video.mp4")}
                                                  >
                                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                      <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                                      />
                                                    </svg>
                                                    Download Video
                                                  </Dropdown.Item>
                                                )}
                                                {hasAudioUrl && (
                                                  <Dropdown.Item
                                                    className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-[#50B5FF]/10 hover:text-[#50B5FF]"
                                                    onClick={() => handleDownload(hasAudioUrl.url, "audio.mp3")}
                                                  >
                                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                      <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                                      />
                                                    </svg>
                                                    Download Audio
                                                  </Dropdown.Item>
                                                )}
                                                {hasDocumentUrl && (
                                                  <>
                                                    <Dropdown.Item
                                                      className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-[#50B5FF]/10 hover:text-[#50B5FF]"
                                                      onClick={() => window.open(hasDocumentUrl, "_blank")}
                                                    >
                                                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                          strokeWidth={2}
                                                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                                        />
                                                        <path
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                          strokeWidth={2}
                                                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                                        />
                                                      </svg>
                                                      View Document
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                      className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-[#50B5FF]/10 hover:text-[#50B5FF]"
                                                      onClick={() => handleDownload(hasDocumentUrl, hasDocumentName)}
                                                    >
                                                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                          strokeWidth={2}
                                                          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                                        />
                                                      </svg>
                                                      Download Document
                                                    </Dropdown.Item>
                                                  </>
                                                )}
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          )}
                                      </div>
                                      <small className={`block text-xs text-gray-500 mt-1.5 ${isCurrentUser ? "text-right" : "text-left"}`}>
                                        {formattedTime}
                                      </small>
                                    </div>
                                    {isCurrentUser && (
                                      <div className="flex-shrink-0 ml-3 mt-2 hidden sm:block">
                                        <img
                                          src={user1}
                                          alt="chat-user"
                                          className="w-10 h-10 object-cover rounded-full ring-1 ring-gray-200"
                                          loading="lazy"
                                        />
                                      </div>
                                    )}
                                  </div>
                                </React.Fragment>
                              );
                            })}
                          </div>
                        ) : (
                          <FsLightbox toggler={imageController.toggler} sources={[Showimg]} />
                        )}
                      </>
                    )}

                    {showEmojiPicker && (
                      <div
                        className="absolute bottom-20 left-4 sm:left-6 bg-white rounded-xl shadow-2xl p-4 z-30 max-w-[320px] w-full"
                        ref={emojiPickerRef}
                      >
                        <EmojiPicker onEmojiClick={handleEmojiClick} />
                      </div>
                    )}

                    {showquickreply && (
                      <div
                        className="absolute bottom-20 left-4 sm:left-6 bg-white rounded-xl shadow-2xl p-4 w-full max-w-[320px] z-30"
                      >
                        <div className="flex justify-between items-center mb-3">
                          <span className="text-gray-900 font-semibold text-sm">Quick Replies</span>
                          <button
                            className="p-1 hover:bg-gray-100 rounded-full transition-all duration-300"
                            onClick={() => setShowQuickReply(false)}
                          >
                            <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                          </button>
                        </div>
                        <ListGroup variant="flush">
                          {filteredQuickReplies?.map((item, index) => (
                            <ListGroup.Item
                              key={index}
                              className="bg-transparent border-0 py-2.5 hover:bg-[#50B5FF]/5 rounded-lg cursor-pointer transition-all duration-200"
                              onClick={() => handleQuickReplies(item.payload)}
                            >
                              <div className="flex flex-col">
                                <span className="text-gray-800 text-sm font-medium truncate">{item.title}</span>
                                <p className="text-gray-500 text-xs mt-1 line-clamp-2">{item.payload || "No Title"}</p>
                              </div>
                            </ListGroup.Item>
                          ))}
                        </ListGroup>
                      </div>
                    )}

                    {Loader === false && (
                      <div className="card-footer bg-white/95 backdrop-blur-sm border-t border-gray-200/50 px-4 sm:px-6 py-3 fixed bottom-0 left-0 right-0 z-20">
                        <ChatInput
                          platform={platform}
                          hasUserMessages={hasUserMessages}
                          canSendTemplate={canSendTemplate}
                          handleSendMessage={handleSendMessage}
                          senderId={senderId}
                          setNewMessage={setNewMessage}
                          newMessage={newMessage}
                          faqs={faqs}
                          templates={"templates"}
                          fbSendMessageloading={fbSendMessageloading}
                          igSendMessageloading={igSendMessageloading}
                          handleFileUpload={handleFileUpload}
                          setShowEmojiPicker={setShowEmojiPicker}
                          showEmojiPicker={showEmojiPicker}
                          setShowQuickReply={setShowQuickReply}
                          setFilteredQuickReplies={setFilteredQuickReplies}
                          inputRef={inputRef}
                          inputFile={inputFile}
                        />
                      </div>
                    )}
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </main> */}
            <Modal
              size="lg"
              centered
              show={show4}
              onHide={handleClose4}
              className="fade"
              dialogClassName=" rounded-2xl max-w-2xl transform transition-all duration-300"
            >
              <Modal.Header className="bg-[#50B5FF] text-white p-6 rounded-t-2xl border-0 flex justify-between items-center">
                <Modal.Title className="h5 text-white font-semibold">Send Message to the User</Modal.Title>
                <button
                  onClick={handleClose4}
                  className="text-white hover:bg-white hover:bg-opacity-20 p-2 rounded-full transition-colors duration-200"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </Modal.Header>
              <Modal.Body className="p-6 space-y-6">
                <Form.Group>
                  <Form.Label className="text-sm font-medium text-gray-700">Message Template</Form.Label>
                  <select
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#50B5FF] focus:border-transparent transition-all duration-200 shadow-sm bg-white"
                    value={selectedTemplate?._id || ""}
                    onChange={handleTemplateChange}
                  >
                    <option value="">Select a template</option>
                    {templates?.map((template) => (
                      <option key={template._id} value={template._id}>
                        {template?.templateName}
                      </option>
                    ))}
                  </select>
                </Form.Group>

                {selectedTemplate &&
                  templates
                    .find((t) => t._id === selectedTemplate?._id)
                    ?.components?.flatMap(
                      (component, compIndex) =>
                        component.text
                          ?.match(/{{\d+}}/g)
                          ?.map((placeholder, index) => {
                            const placeholderKey = placeholder.match(/{{(\d+)}}/)[1];
                            return (
                              <Form.Group key={`${compIndex}-${index}`} className="mb-4">
                                <Form.Label className="text-sm font-medium text-gray-700">
                                  Parameter ({placeholder}) - {component.type}
                                </Form.Label>
                                <input
                                  type="text"
                                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#50B5FF] focus:border-transparent transition-all duration-200 shadow-sm"
                                  value={payloadValues[placeholderKey] || ""}
                                  onChange={(e) =>
                                    setPayloadValues({
                                      ...payloadValues,
                                      [placeholderKey]: e.target.value,
                                    })
                                  }
                                  placeholder={`Enter value for ${placeholder}`}
                                />
                              </Form.Group>
                            );
                          }) || []
                    )}

                <Card className="bg-[#50B5FF] bg-opacity-90 text-white rounded-xl shadow-md">
                  <Card.Body className="p-4">
                    <Card.Title as="h4" className="text-white font-semibold mb-2">
                      {selectedTemplate
                        ? templates.find((t) => t._id === selectedTemplate?._id)?.templateName
                        : "No Message Type Selected"}
                    </Card.Title>
                    <blockquote className="blockquote mb-0">
                      <p className="text-gray-100 text-base">{getUpdatedText()}</p>
                    </blockquote>
                  </Card.Body>
                </Card>
              </Modal.Body>
              <Modal.Footer className="bg-gray-50 p-6 rounded-b-2xl border-0 flex justify-end space-x-4">
                <Button
                  variant="outline-secondary"
                  onClick={handleClose4}
                  className="px-6 py-2 rounded-lg font-medium text-gray-700 hover:bg-gray-200 transition-all duration-200 shadow-sm"
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={() => handleSendMessage(platform)}
                  className="px-6 py-2 bg-[#50B5FF] text-white rounded-lg font-medium hover:bg-[#50B5FF]-600 transition-all duration-200 shadow-md hover:shadow-lg"
                >
                  Send Message
                </Button>
              </Modal.Footer>
            </Modal>
          </Tab.Container>
      }
    </>
  );
};
export default AllChat;




